<template>
  <div>
    <picture-in-picture :isDraggableRequired="true" ref="pic-pic" @hook:mounted="picPicZindex( 99999, 'pic-pic')" calss="hide-picture" v-cloak v-if="openPip" :selectedFile="selectedFileInfo"  @closeMiniPlayer="closeMinimisedPlayer"></picture-in-picture>
    <ImagePreviewDialog ref="fullscreen-pic" @hook:mounted="picPicZindex(  99999, 'fullscreen-pic')" class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="selectedFileInfo" @closeMiniPlayer="closeMinimisedPlayer"
       v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
    <div class="modal files-browse-modal-bins-and-catalog" tabindex="-1" role="dialog" :class="{'blaze-fusion-browse-top-0': $route && $route.name == 'blaze_fusion_browse'}" style="z-index:9999">
      <div class="modal-dialog" :class="{'blaze-fusion-browse': $route && $route.name == 'blaze_fusion_browse'}" role="document">
        <div class="modal-content">
          <div class="modal-header p-2">
            <div v-if="workspaceList.length == 1" style="height:23px;width:20px;margin-inline-end: 6px;">
                  <img :src="logo" style="height:100%;width:100%">
            </div>
            <h6 class="modal-title">{{$route && $route.name != 'blaze_fusion_browse' ? 'Browse ' : 'Fusion Browse' }}<span v-if="workspaceList.length == 1" style="text-transform: capitalize;">{{workspaceList[0]}}</span></h6>
            <button type="button" :style="$route && $route.name == 'blaze_fusion_browse' ? 'visibility:hidden;' : '' " class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
              <span aria-hidden="true">
                <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;">
                </cancel-icon>
              </span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="h-100">
              <div style="display:flex;display: flex;padding: 6px 10px;">
                <div v-show="workspaceList.length > 1" style="height:38px;width:35px;">
                  <img :src="logo" style="height:100%;width:100%">
                </div>
                <div class="navbar-header container-fluid" :class="[{overWriteContMargin:workspaceList.length > 1},{overWriteContainer: workspaceList.length == 1}]">
                  <div class="search-bar-autocomplete-wrapper fusion-browse-search-wrapper" style="position:relative;width:60%;display: flex;">
                    <div v-if="!(showBins && selectedComponent == 'bins-display-component')" class="fusion-browse-search-input" style="display:inline-block;width:94%">
                      <div style="width:100%;position:relative" @keyup.enter.stop.prevent="keywordSearchParameters()">
                        <Multiselect
                                    ref="globalSearch"
                                    id="gloabl_search_in_file_browse"
                                    v-model="keywordFilter"
                                    :options="searchKeywordListFromAutocomplete"
                                    :custom-label="selectionLabelCallback"
                                    :placeholder="(showBins && selectedComponent == 'bins-display-component')?$t('Search bins'):$t('Search')"
                                    :preserveSearch="true"
                                    :show-no-results="false"
                                    :noOptions="true"
                                    :multiple="false"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :allowEmpty="false"
                                    :clearOnSelect="false"
                                    :showNoOptions="false"
                                    @hook:mounted ="setAutocompleteOff()"
                                    @open="open"
                                    @keyup.enter.stop.prevent="keywordSearchParameters()"
                                    @search-change="getSearchKeywordsOnKeyup($event)"
                                    @select="keywordOptionsOnSelectCallback($event)"
                                    @remove="SearchKeywordOptionsOnRemoveCallback()"
                                    class="search-bar bg-transparent border-dark rounded"
                                    name="search"
                                    style="width:100% !important">
                        </Multiselect>
                        <svg v-if="keywordFilter != ''" v-on:click.prevent="clearSearchBarTextOnly()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg clear-icon" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
                          <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
                        </svg>
                        <svg @click="keywordSearchParameters()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search search-icon" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                        </svg>
                      </div>
                      
                    </div>
                    <div class="fusion-browse-search-icon-slot" style="width:6%;display: flex;justify-content: center;">
                      <svg v-if="(selectedComponent == 'catalogs-display-component' || (selectedComponent == 'bins-display-component' && !showBins)) && !enableOnlyFolders" @click="enableAdvancedSearchFunc()" :style='enableAdvancedSearch?"fill:#0779fb":""' xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        class="bi bi-sliders slider-icon" :class="{overWriteAdvIcon:workspaceList.length == 1}" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <!-- <ul class="navbar-nav" style="position:relative;inset-inline-start:22px;width:60%;justify-content:flex-end">
                  <li class="nav-item" style="position:relative;inset-inline-start:4px">
                    <a class="nav-item nav-link"  v-on:click="changeViewTypes()" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <svg xmlns="http://www.w3.org/2000/svg" v-if="gridView" width="2em" height="2em" fill="#C5c0c0" class="bi bi-grid-3x3-gap-fill" viewBox="0 0 16 16">
                      <title>Grid view</title>
                      <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" v-if="!gridView" width="2em" height="2em" fill="#C5c0c0" class="bi bi-list-task" viewBox="0 0 16 16">
                      <title>Table view</title>
                      <path fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"/>
                      <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z"/>
                      <path fill-rule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"/>
                    </svg>
                    </a>
                  </li>
                </ul> -->
              </div>
              <div class="container-fluid sidenav">
                <div style="height:calc(100% - 140px);display:inline-flex;width:100%;" :class="{'blaze-fusion-browse-full-height': $route && $route.name == 'blaze_fusion_browse'}">
                  <div v-if='workspaceList.length > 1' class="sidebar-main p-0" style="width: calc(100% - 93%);" :style="isFusionOpenedInsideIframe ? 'min-width:60px !important;':''">
                    <nav class="sidebar-wrapper">
                      <ul class="sidebar-menu" style="list-style-type:none;padding:4px">
                        <li v-if="vWorkspace['catalogs']" class="sidebar text-left d-inline-block w-100"
                          :class="{activePanel: 'catalogs-display-component' === selectedComponent}" @click="switchWorkpace('catalogs-display-component')">
                          <div class="text-center">
                            <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-hdd" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" d="M14 9H2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM2 8a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H2z"></path>
                              <path d="M5 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"></path>
                              <path fill-rule="evenodd" d="M4.094 4a.5.5 0 0 0-.44.26l-2.47 4.532A1.5 1.5 0 0 0 1 9.51v.99H0v-.99c0-.418.105-.83.305-1.197l2.472-4.531A1.5 1.5 0 0 1 4.094 3h7.812a1.5 1.5 0 0 1 1.317.782l2.472 4.53c.2.368.305.78.305 1.198v.99h-1v-.99a1.5 1.5 0 0 0-.183-.718L12.345 4.26a.5.5 0 0 0-.439-.26H4.094z"></path>
                            </svg>
                          </div>
                          <div class="text-center">
                            <span>Catalogs</span>
                          </div> 
                        </li>
                        <li  v-if="vWorkspace['bins']" class="sidebar text-left d-inline-block w-100"
                          :class="{activePanel: 'bins-display-component' === selectedComponent}" @click="switchWorkpace('bins-display-component')">
                          <div class="text-center">
                            <svg width="1.5em" height="2em" style="undefined" viewBox="0 0 16 16" class="bi bi-server" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4C14.665 5.474 11.68 6.667 8 6.667 4.318 6.667 1.333 5.473 1.333 4V2.667zm0 3.667v3C1.333 10.805 4.318 12 8 12c3.68 0 6.665-1.193 6.667-2.665V6.334c-.43.32-.931.58-1.458.79C11.81 7.684 9.967 8 8 8c-1.967 0-3.81-.317-5.21-.876a6.508 6.508 0 0 1-1.457-.79zm13.334 5.334c-.43.319-.931.578-1.458.789-1.4.56-3.242.876-5.209.876-1.967 0-3.81-.316-5.21-.876a6.51 6.51 0 0 1-1.457-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z"></path>
                            </svg>
                          </div>
                          <div class="text-center">
                            <span>Bins</span>
                          </div> 
                        </li>
                          
                          <li v-for="menu in browsePlugins" class="sidebar text-left d-inline-block w-100" @click="handleBrowsePluginClicks(menu)" :class="getClass(menu)" :key="menu.id">
                            <div class="text-center">
                              <div v-html="menu.svgIcon"></div>
                            </div>
                            <div class="text-center">
                              <span>{{menu.label}}</span>
                            </div>
                          </li>

                        <!-- <li  v-if="vWorkspace['tickets']" class="sidebar text-left d-inline-block w-100"
                          :class="{activePanel: 'tickets-display-component' === selectedComponent}" @click="switchWorkpace('tickets-display-component')">
                          <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="2em" fill="currentColor" class="bi bi-ticket-detailed" viewBox="0 0 16 16">
                              <path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM5 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5Z"></path>
                              <path d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5ZM1.5 4a.5.5 0 0 0-.5.5v1.05a2.5 2.5 0 0 1 0 4.9v1.05a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1.05a2.5 2.5 0 0 1 0-4.9V4.5a.5.5 0 0 0-.5-.5h-13Z"></path>
                            </svg>
                          </div>
                          <div class="text-center">
                            <span>Tickets</span>
                          </div>
                        </li> 

                        <li  v-if="vWorkspace['tasks']" class="sidebar text-left d-inline-block w-100"
                          :class="{activePanel: 'tasks-display-component' === selectedComponent}" @click="switchWorkpace('tasks-display-component')">
                          <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="2em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-ui-checks-grid">
                              <path d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z">
                              </path>
                            </svg>
                          </div>
                          <div class="text-center">
                            <span>Tasks</span>
                          </div>
                        </li>
                        <li  v-if="vWorkspace['issues']" class="sidebar text-left d-inline-block w-100"
                          :class="{activePanel: 'issues-display-component' === selectedComponent}" @click="switchWorkpace('issues-display-component')">
                          <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="2em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-bug-fill">
                              <path d="M4.978.855a.5.5 0 1 0-.956.29l.41 1.352A4.985 4.985 0 0 0 3 6h10a4.985 4.985 0 0 0-1.432-3.503l.41-1.352a.5.5 0 1 0-.956-.29l-.291.956A4.978 4.978 0 0 0 8 1a4.979 4.979 0 0 0-2.731.811l-.29-.956z"></path><path d="M13 6v1H8.5v8.975A5 5 0 0 0 13 11h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 1 0 1 0v-.5a1.5 1.5 0 0 0-1.5-1.5H13V9h1.5a.5.5 0 0 0 0-1H13V7h.5A1.5 1.5 0 0 0 15 5.5V5a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5H13zm-5.5 9.975V7H3V6h-.5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-1 0v.5A1.5 1.5 0 0 0 2.5 7H3v1H1.5a.5.5 0 0 0 0 1H3v1h-.5A1.5 1.5 0 0 0 1 11.5v.5a.5.5 0 1 0 1 0v-.5a.5.5 0 0 1 .5-.5H3a5 5 0 0 0 4.5 4.975z">
                              </path>
                            </svg>
                          </div>
                          <div class="text-center">
                            <span>Issues</span>
                          </div>
                        </li> -->
                      </ul>
                    </nav>
                  </div>
                  <div class="p-0 d-inline-flex h-100" :style="{'width':resizeAssetsWidth}">
                    <div class="h-100 p-0 w-100" :class="{unhideMetaDockComponent : 'col-md-8', getIsAssetsDetailsPanelVisible : 'col-md-12'}">
                      <config-advanced-search :disableEditMode="true"  :key="$route.fullPath" v-if="enableAdvancedSearch && !enableOnlyFolders && browseContext == 'catalogs-display'" searchContext="catalogs-display" compType="mainComp"
                      @advancedSearchData="advancedSearchData" @hideAdvancedSearch="enableAdvancedSearch = false" :class="{'blaze-advanced-search': $route && $route.name == 'blaze_fusion_browse'}" @hook:mounted="loadBlazeSearchFilters()" @hook:beforeDestroy="removeBlazeSearchFilterListener('configAdvancedSearchRef')" ref="configAdvancedSearchRef"></config-advanced-search>
                      <advanced-search v-else-if="enableAdvancedSearch && !enableOnlyFolders && !(showBins && selectedComponent == 'bins-display-component')" :searchContext="browseContext" compType="subComp" @advancedSearchData="advancedSearchData" :class="{'blaze-advanced-search': $route && $route.name == 'blaze_fusion_browse'}" @hook:mounted="addBlazeSearchFilterListener('advanceSearchRef')" @hook:beforeDestroy="removeBlazeSearchFilterListener('advanceSearchRef')" ref="advanceSearchRef"></advanced-search>
                        <div  v-if='showBins && selectedComponent == "bins-display-component"'>
                            <bins-display ref="binsDisplay" @changeSelectedMainComponent="selectedMainComponent" @selectedRootBin="handleSelectedRootBin" :preSelectedBinIds="parentPreSelectedPathIds" :enabledFolderBrowse="enableOnlyFolders" :enableMultiSelect="enableAssetMultiSelect"></bins-display>
                        </div>
                        <div :style="{'height':resizedHeight}">
                          <template v-if="['catalogs-display-component','bins-display-component'].includes(selectedComponent)">
                                <div style="margin-inline-end: 30px !important;">
                                  <top-nav
                                    @changeDirectoryFromUrl="changeDir" 
                                    @changeComponent="changeComponent"
                                    compoentType="FileBrowserWorkspace"
                                    :dirs="dirs"
                                    :usedBy="usedByCLabel"
                                    :sortedOption="sortBy"
                                    v-on:sort-by-filter-updated="sortBinsTable"
                                    @fileStateFilterUpdated="updateFileStateFilter"
                                    :folderBrowseEnabled="enableOnlyFolders"
                                    >
                                  </top-nav>
                                </div>
                                <div
                                  v-if="gridView == true"
                                  class="assets-view-wrapper"
                                  :ripple="false"
                                  data-app
                                  :class="isFusionOpenedInsideIframe ? 'fusion-inside-iframe-plugin': ''"
                                  >
                                  <div v-if="filesList.files.length == 0 && filesList.dirs.length == 0" style="text-align: center !important;">
                                    <div style="font-size: 20px; margin-top: 8%; color: #686868;">
                                      No Data Found
                                    </div>
                                  </div>
                                  <div v-if="filesList.dirs.length !== 0 && (selectedComponent =='bins-display-component' || (selectedComponent =='catalogs-display-component' && filesList.dirs && filesList.dirs.filter(op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type)))).length > 0))">
                                    <div
                                      class="text-left"
                                      style="padding: 10px 0px 0px 20px; color: #777"
                                      >
                                    <svg  v-if="!showFolders" v-on:click="showFolders = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                    </svg>
                                    <svg v-if="showFolders" v-on:click="showFolders = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                    </svg>
                                    <span v-if="selectedComponent =='catalogs-display-component'">Catalogs</span>
                                    <span v-else>Folders</span>
                                    </div>
                                    <ul v-if="showFolders &&
                                              ((selectedComponent =='catalogs-display-component' && filesList.dirs.filter(op=>(!('catalog_type' in op) || !['photo_album','package'].includes(op.catalog_type))).length) ||
                                               (selectedComponent == 'bins-display-component'))" class="thumbnail-view-ul folder-view-ul">
                                      <!-- <drag-select-container style="display:contents" attribute="attr" @change="dragSelect($event)"> -->
                                        <li class="folder-view-li"
                                            v-for="file in getFolderList"
                                            :title="(selectedComponent == 'catalogs-display-component')?file['catalog_name']:getFileName(file)"
                                            :key="file.file_uid"
                                            :attr="file.file_uid"
                                            @click.ctrl="multiSelectElemet(file)"
                                            @click.exact="selectElement($event, file)"
                                            @dblclick="showAssetDetails(file)"
                                            :class="{ activeAsset: fileUuids.includes(file._id) || ('file_uid' in file && fileUuids.includes(file.file_uid)) }"
                                            :ripple="false"
                                            data-app
                                            >
                                            <div class="folder-view">
                                              <template v-if="selectedComponent == 'catalogs-display-component'">
                                                <template v-if="'catalog_cover_photo_path' in file && file.catalog_cover_photo_path.trim().length > 0">
                                                  <div class="card" style="width: 34px; height: 78%; top:6px; overflow: hidden; display: flex; background-color: rgb(45, 57, 60); border: 1px solid rgb(58, 58, 58);border-radius: 7px;">
                                                    <img class="card-img-top" :src="getCatalogCoverPhoto(file)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;">
                                                  </div>
                                                </template>
                                                <template v-else>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                    <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                                  </svg>
                                                </template>
                                              </template>
                                              <svg v-else
                                                width="1em"
                                                height="1em"
                                                viewBox="0 0 16 16"
                                                class="bi bi-folder-fill"
                                                fill="#939393"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  fill-rule="evenodd"
                                                  d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"
                                                />
                                              </svg>
                                            </div>
                                            <div class="folder-data">
                                              <span v-if="selectedComponent == 'catalogs-display-component'">{{file.catalog_name}}</span>
                                              <span v-else>{{ getFileName(file) }}</span>
                                            </div>
                                        </li>
                                      <!-- </drag-select-container> -->
                                    </ul>
                                  </div>
                                  <template v-if="selectedComponent =='catalogs-display-component' && filesList.dirs && filesList.dirs.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album')).length > 0">
                                  <div class="text-left" style="padding: 10px 0px 0px 20px; color: #777">
                                    <svg  v-if="!showAlbums" v-on:click.stop.prevent="showAlbums = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                    </svg>
                                    <svg v-if="showAlbums" v-on:click.stop.prevent="showAlbums = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                    </svg>
                                    {{$t('Photo Albums')}}
                                  </div>
                                  <ul v-if="showAlbums"
                                    class="thumbnail-view-ul folder-view-ul" style="overflow: unset;">
                                    <li
                                      v-for="catalog in filesList.dirs.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album'))"
                                      :key="catalog._id"
                                      :attr="catalog._id"
                                      @click.exact="selectElement($event,catalog)"
                                      :class="{ activeAsset: fileUuids.includes(catalog._id), 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE'}"
                                      @click.ctrl="multiSelectElemet(catalog)"
                                      @dblclick="showAssetDetails(catalog)"
                                      @contextmenu.stop.prevent="show($event, catalog)"
                                      :ripple="false"
                                      :title="catalog.catalog_name"
                                      data-app
                                      style="position: relative;height:auto;width:auto;padding-inline-start:0px"
                                      >
                                      <div class="asset-thumbnail" style="height: 200px !important;width: 174px !important;margin-top:0px">
                                      <div class="card" style="width: 172px; height: 100%; overflow: hidden; display: flex; background-color: rgb(45, 57, 60); border: 1px solid rgb(58, 58, 58);border-radius: 7px;">
                                        <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;">
                                        <div class="card-body" style="width: inherit; display: flex; align-items: center; padding: 0px 7px 0px 7px; position: absolute; height: 45px; background-color: rgba(3, 4, 4, 0.7);border-radius: 0px 0px 7px 7px;bottom:0px">
                                          <div style="width:100%;display:inline-block;text-align:start">
                                            <div style="overflow: hidden;text-overflow: ellipsis;" :title="catalog.catalog_name">
                                              <div  v-if="catalog.highlight && catalog.highlight['catalog_name']" class="transcript-content-wrapper"
                                              style="display:flex;width: 100%; align-items: flex-start;">
                                                <div style="flex: 1;">
                                                  <span v-for="(cContent,index) in catalog.highlight['catalog_name']" :key="'catalog_name'+index" v-html="getHighlightContent(cContent)"  class="transcript-content-highlight" style="white-space: pre-wrap;"></span>
                                                </div>
                                              </div>
                                              <span v-else>{{catalog.catalog_name}}</span>
                                            </div>
                                            <div style="width:100%;font-size: 12px;display:inline-flex;color:#adadad">
                                              <template v-if="'album_assets_count' in catalog && catalog.album_assets_count > 0">
                                                <div v-if="catalog.album_assets_count > 1" style="width:50%">{{catalog.album_assets_count}} {{$t('files')}}</div>
                                                <div v-else-if="catalog.album_assets_count <= 1" style="width:50%">{{catalog.album_assets_count}} {{$t('file')}}</div>
                                              </template>
                                              <div v-else style="width:50%">0 {{$t('files')}}</div>
                                              <div style="width:50%;text-align:end">{{formatedDate(catalog.asset_created_datetime)}}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div v-if="catalog.asset_state == 'GROWING'">
                                        <img :src="growingFileGif"
                                              alt="loading"
                                              style="height:50px;width:65px;position:absolute;bottom:40%;inset-inline-start:28%"
                                            />
                                      </div>
                                      <div v-else-if="catalog.state == 'ERROR'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:49%;inset-inline-start:41%">
                                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                                          <title>ERROR</title>
                                        </svg>
                                      </div>
                                      <div v-else-if="catalog.asset_state == 'MARK FOR DELETE'">
                                        <img
                                          :src="markForDeleteIcn"
                                          alt="markfordelete"
                                          style="height:25px;width:29px;position:absolute;bottom:47%;inset-inline-start:42%"
                                          />
                                      </div>
                                    </div>
                                    </li>
                                  </ul>
                                  </template>
                                  <template v-if="selectedComponent =='catalogs-display-component' && filesList.dirs && filesList.dirs.filter(op=>('catalog_type' in op && op.catalog_type == 'package')).length > 0">
                                  <div class="text-left" style="padding: 10px 0px 0px 20px; color: #777">
                                    <svg  v-if="!showPackages" v-on:click.stop.prevent="showPackages = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                    </svg>
                                    <svg v-if="showPackages" v-on:click.stop.prevent="showPackages = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                    </svg>
                                    {{$t('Packages')}}
                                  </div>
                                  <ul v-if="showPackages"
                                    class="thumbnail-view-ul folder-view-ul" style="overflow: unset;">
                                    <li class="folder-view-li"
                                      v-for="file in filesList.dirs.filter(op=>('catalog_type' in op && op.catalog_type == 'package'))"
                                      :title="file['catalog_name']"
                                      :key="file.file_uid"
                                      :attr="file.file_uid"
                                      @click.ctrl="multiSelectElemet(file)"
                                      @click.exact="selectElement($event, file)"
                                      @dblclick="showAssetDetails(file)"
                                      :class="{ activeAsset: fileUuids.includes(file._id) || ('file_uid' in file && fileUuids.includes(file.file_uid)) }"
                                      :ripple="false"
                                      data-app
                                      >
                                      <div class="folder-view">
                                        <template v-if="selectedComponent == 'catalogs-display-component'">
                                          <template v-if="'catalog_cover_photo_path' in file && file.catalog_cover_photo_path.trim().length > 0">
                                            <div class="card" style="width: 34px; height: 78%; top:6px; overflow: hidden; display: flex; background-color: rgb(45, 57, 60); border: 1px solid rgb(58, 58, 58);border-radius: 7px;">
                                              <img class="card-img-top" :src="getCatalogCoverPhoto(file)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;">
                                            </div>
                                          </template>
                                          <template v-else>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-collection-fill" viewBox="0 0 16 16">
                                              <path d="M0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6zM2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3m2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1"/>
                                            </svg>
                                          </template>
                                        </template>
                                        <svg v-else
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 16 16"
                                          class="bi bi-folder-fill"
                                          fill="#939393"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"
                                          />
                                        </svg>
                                      </div>
                                      <div class="folder-data">
                                        <span v-if="selectedComponent == 'catalogs-display-component'">{{file.catalog_name}}</span>
                                        <span v-else>{{ getFileName(file) }}</span>
                                      </div>
                                    </li>
                                  </ul>
                                  </template>
                                  <div v-if=" !enableOnlyFolders && filesList.files.length !== 0" style="height: inherit;">
                                    <div
                                      class="text-left"
                                      style="padding: 10px 0px 0px 20px; color: #777"
                                      >
                                      <input v-if="enableAssetMultiSelect" v-on:change.stop="selectAllFiles" v-model='allFilesSelected' type="checkbox" class="text-light bigger-checkboxes" style="position: relative;top: 11px;inset-inline-end :5px;">
                                      <svg  v-if="!showFiles" v-on:click="showFiles = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                      </svg>
                                      <svg v-if="showFiles" v-on:click="showFiles = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                      </svg>Files
                                    </div>
                                    <ul v-if="showFiles" class="thumbnail-view-ul common-view-ul">
                                      <!-- <drag-select-container attribute="attr" style="display:contents" @change="dragSelect($event)"> -->
                                        <li
                                          v-for="file in filesList.files"
                                          :key="file.file_uid"
                                          :attr="file.file_uid"
                                          @click.ctrl="multiSelectElemet(file)"
                                          @click.exact="selectElement($event, file)"
                                          @dblclick="showAssetDetails(file)"
                                          :class="{ activeAsset: fileUuids.includes(file.file_uid) }"
                                          :ripple="false"
                                          data-app
                                          style="position:relative"
                                          :title="getFileName(file)"
                                            >
                                          <div class="asset-thumbnail" onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue=false" >
                                            <div v-if='checkIfDisabled(file)' :id="'assetResolution_'+file._id" class="thumbnail-view-resolution-label">
                                                {{ getReadableResolutionValue(file) }}
                                            </div>
                                            <div class="thumbnail-view" style="height: 93px;width: 160px;" :class="file.state == 'MARK FOR DELETE'?'reduce-opacity':' '">
                                              <img :src="getThumbnailPath(file,'FOR_SVG_THUMBNAIL')" @error="(e) => replaceByDefaultImage(e,file,'FOR_SVG_THUMBNAIL')" alt="image" draggable="false"/>
                                              <div v-if="'mime_type' in file && (file.mime_type.startsWith('video') || file.mime_type.startsWith('audio')) && 'duration' in file && file.duration"
                                                    class="thumbnail-view-duration-label">
                                                    {{getHumanReadableDuration(file.duration)}}
                                              </div>
                                            </div>
                                            <div class="storage-type-icons-wrapper" v-if="(file.storage_class != undefined && file.storage_class.length) || file.asset_type == 'subclip' || file.subclips_present == true">
                                              <svg v-if="file.subclips_present == true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                <title>Have subclips</title>
                                              </svg>
                                              <div v-if="file.asset_type == 'subclip'" style="position:relative;inset-inline-start:4px;width:34px">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                                  <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                                  <title>Subclip</title>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :5px;">
                                                  <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                                  <title>Subclip</title>
                                                </svg>
                                              </div>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                <title>Amazon S3 Glacier</title>
                                              </svg>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Deep Archive')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                <title>Amazon S3 Glacier Deep Archive</title>
                                              </svg>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                <title>Amazon S3 Glacier Instant Retrieval</title>
                                              </svg>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Standard')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                <title>Amazon S3 Standard</title>
                                              </svg>
                                              <svg xmlns="http://www.w3.org/2000/svg" v-if="Object.keys(file).includes('archived') && file.archived" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16">
                                                <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                                                <title>Archived</title>
                                              </svg>
                                              <template v-if="'location_info' in file && 'gravity_deep' in file.location_info">
                                                <div v-for="cId of file.location_info.gravity_deep.container_ids" :key="cId">
                                                  <svg v-if="cId == 'CACHE'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-square" viewBox="0 0 16 16">
                                                    <title>{{ cId }}</title>
                                                    <path d="M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"/>
                                                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"/>
                                                  </svg>
                                                  <svg v-else-if="cId.startsWith('Tape')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cassette-fill" viewBox="0 0 16 16">
                                                    <title>{{ cId }}</title>
                                                    <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"/>
                                                    <path d="m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"/>
                                                  </svg>
                                                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                                                    <title>{{ cId }}</title>
                                                    <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                                                  </svg>
                                                </div>
                                              </template>
                                            </div>
                                            <div v-if="!['GROWING'].includes(file.state) && file.asset_type != 'subclip'" class="shortcut-actions-type-icons-wrapper">
                                              <template v-if="!['MARK FOR DELETE'].includes(file.state)">
                                                <svg v-if="isPEnabled('Download')" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                  <title>Download</title>
                                                  <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                  <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                </svg>
                                              </template>
                                              <svg @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                                <title>Preview</title>
                                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                              </svg>
                                              <div class="overflow-parent-div">
                                                <svg @click.stop.prevent="eOMenu=!eOMenu" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                                  <title>More actions</title>
                                                  <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                                </svg>
                                                <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                                      <div class="copy-link-action" @click="setClipBoardText(file)" title="Copy link">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fdfff4" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                            <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                            <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                        </svg>
                                                        Copy link</div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="thumbnail-data d-inline-flex">
                                            <div v-html="getSvgIconsOfMediaTypes(file)" class="svg-icons-display"></div>
                                              <div class="file-name" :title="getFileName(file)" v-if="!getHighlightFilename(file,getFileName(file)).highlight" :style="globalSettingsFromStartup.enable_file_extension?'':'max-width:140px !important'" style="display:flex">
                                                <span class="dynamic-slug-name">{{ getFileName(file) }}</span>
                                                <span class="file-extension-thumbnail-view" v-if="globalSettingsFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
                                              </div>
                                              <div class="file-name" :title="getFileName(file)" v-else :style="globalSettingsFromStartup.enable_file_extension?'':'max-width:140px !important'" style="display:flex;">
                                                <span class="dynamic-slug-name" v-html="getHighlightFilename(file,getFileName(file)).slugname"></span>
                                                <span class="file-extension-thumbnail-view" v-if="globalSettingsFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
                                              </div>
                                          </div>
                                          <div v-if="(selectedComponent == 'catalogs-display-component' && file.asset_state != 'READY'
                                                      && file.asset_state != 'MARK FOR DELETE') ||
                                                      ('state' in file && file.state != 'READY' && file.state != 'MARK FOR DELETE')">
                                            <img
                                              :src="growingFileGif"
                                              alt="loading"
                                              style="height:50px;width:65px;position:absolute;bottom:40%;inset-inline-start:28%"
                                            />
                                          </div>
                                          <div v-else-if="(selectedComponent == 'catalogs-display-component' &&
                                                          file.asset_state == 'MARK FOR DELETE') ||
                                                          ('state' in file && file.state == 'MARK FOR DELETE')">
                                            <img
                                              :src="markForDeleteIcn"
                                              alt="markfordelete"
                                              style="height:20px;width:20px;position:absolute;bottom:55%;inset-inline-start:42%"
                                            />
                                          </div>
                                        </li>
                                      <!-- </drag-select-container> -->
                                    </ul>
                                  </div>
                                </div>
                          </template>

                          <!-- v-bind="getProjectsProps()" -->
                          <component @hook:beforeDestroy="handlePAMBrowseDestroy" ref="pam-browse-ref" :key="PAMBrowseSelectedComponent.id" v-if="!selectedComponent && PAMBrowseSelectedComponent" :is="PAMBrowseSelectedComponent.component" v-bind="{workspaceList,keywordFilter,unselectAllFiles,enableAssetMultiSelect,customModelTitle,browseOnlyFolders,enableRecursive,parentPreSelectedPathIds,allowedPermissions,supportedBrowseMimeType,getPAMProps,page}"></component>

                          <div>
                            <pagination
                              v-model="page"
                              :records="totalFiles"
                              :per-page="perPage"
                              @paginate="paginate"
                              :options="options"
                            />
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="display: inline-flex;z-index:9999;">
            <div v-if="enableRecursive" style="padding-inline-start: 15px; width: 75%;float: inline-start;margin: 0px !important;">
              <div class="custom-control custom-switch">
                <input  v-model="activeIndexInfo.apply_recursively"
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch1"
                  :checked='activeIndexInfo.apply_recursively'/>
                <label class="custom-control-label" for="customSwitch1">
                  Apply recursively for all the sub folders.
                </label>
              </div>
            </div>
            <div class="p-0 primary-btn-style" style="margin: 0px !important;display: inline-flex;justify-content: end;">
              <button class="btn btn-outline-secondary mr-3" v-show="$route && $route.name != 'blaze_fusion_browse'" data-dismiss="modal" @click="close">Cancel</button>
              <button class="btn btn-outline-primary mr-3" @click='handleFileSelection()'>Add</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from "../core/Topnavigation.vue";
import binsDisplay from "../bins/BinsDisplay.vue";
import { mapMutations, mapActions, mapGetters } from "vuex";
import Utils from "../../components.utils.js";
import {NotifierConstants} from "../../components.constants.js";
import CancelIcon from "../core/InlineCancelField.vue";
import Multiselect from 'vue-multiselect';
// import DragSelect from "drag-select-vue";
import Pagination from "vue-pagination-2";
import AdvancedSearch from "../core/AdvancedSearch.vue";
import PictureInPicture from "./MiniPlayer.vue";
import ImagePreviewDialog from '../core/ImagePreviewDialog.vue';
import Constants from "../../components.constants.js";
import highlightMixin from '../../mixins/highlightMixin.js';
import userMultiSelect from "../users/UserMultiselectField.vue";
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import ConfigurableAdvancedSearch from "../core/ConfigurableAdvancedSearch.vue";

Vue.use(VueCookies)

export default {
  mixins:[highlightMixin],
  components: {
    "users-multiselect":userMultiSelect,
    "picture-in-picture":PictureInPicture,
    ImagePreviewDialog,
    "advanced-search":AdvancedSearch,
    // 'drag-select-container': DragSelect,
    "Multiselect":Multiselect,
    "top-nav": TopNav,
    pagination: Pagination,
    "bins-display":binsDisplay,
    "cancel-icon": CancelIcon,
    "config-advanced-search":ConfigurableAdvancedSearch
  },
  computed: {
    isFusionOpenedInsideIframe(){
      try{
          if(window.self !== window.top){
             return true;
          }
      }catch(e){console.log(e)}
      return false;
    },
    getPAMProps(){
      if(this.PAMBrowseSelectedComponent){
         return this.PAMBrowseSelectedComponent.props()
      }
      return null;
    },
    globalSettingsFromStartup:{
        get(){
            return this.$store.state.startUpData.startUpDataDetails;
        }
    },
    getFolderList(){
      if(this.selectedComponent =='catalogs-display-component'){
        return this.filesList.dirs.filter(op=>(!('catalog_type' in op) || !['photo_album','package'].includes(op.catalog_type)));
      }else{
        return this.filesList.dirs;
      }
    },
    dirs() {
      let traversedFolders = this.getTraversedFolderList();
      return traversedFolders;
    },
    ...mapGetters("users", [
      "getisMiniplayerVisible",
      "getLoggedInUserAccessControl",
      "getLoggedInUserPrivilege"
    ]),
    // ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
  },
  methods: {
    handlePAMBrowseDestroy(){
      // this.PAMBrowseSelectedMenu = null;
    },
    getProjectComponent(){
        let f = this.browsePlugins.find((e)=>{
            if(e && e.commonPAMComponet && e.component){
               return e;
            }
        });
        console.log("f..........",f);
        return f.component;
    },
    evaluateProjects(){
      let f = this.browsePlugins.find((e)=>{
            if(e && e.commonPAMComponet && e.component){
               return e;
            }
        });

        if(f){
         return f.evaluateProjects(this);
        }
        return false;
    },
    getProjectsProps(){
       let f = this.browsePlugins.find((e)=>{
            if(e && e.commonPAMComponet && e.component){
               return e;
            }
        });
        return f.props(this);
    },
    handleBrowsePluginClicks(menu){
      console.log("[handleBrowsePluginClicks]");
      this.PAMBrowseSelectedMenu = menu.id;
      menu.click(menu,this);
    },
    getClass(pluginInfo){
       if(pluginInfo && pluginInfo.getClass && typeof pluginInfo.getClass == 'function'){
           return pluginInfo.getClass(this.PAMBrowseSelectedMenu);
       }
       return null;
    },
    async handleDownloadAction(file){
      let payload = {element_type: "file", job_name: "Download"};
      let fileName = file.slug_name;
      if(file.asset_type && file.asset_type == "subclip"){
          let that = this;
          let myPromise = new Promise(function(resolve) {
          let payloadTemp = {params:{assetId: file.master_asset_id}}
          that.getAssetInfoFromServer(payloadTemp).then((data) => {
            if(data["asset"]){
              resolve(data["asset"]);
            }
          })
        });
        let parentInfo = await myPromise;
        payload.bin_id = parentInfo.bin_id;
        payload.path = parentInfo.path;
        payload.file_name = parentInfo.file_name;
        fileName = parentInfo.slug_name;
      }else{
        payload.bin_id = file.bin_id;
        payload.path = file.path;
        payload.file_name = file.file_name;
      }
      this.initiateDownloadJob(payload).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
          let jobIdFromResponse = data.job_id;
          let payload = {};
          payload = { job_id: "job_id=" + jobIdFromResponse };
          let downnloadUrl = `${Constants.downloadUrl}?${payload.job_id}`;
          const link = document.createElement("a");
          link.href = downnloadUrl;
          link.download = fileName;
          link.click(); 
          console.log("Download initiated");
        } else {
          this.$toast.error(data.message);
        }
      })
    },
    getHighlightContent(content){
      if(content && content.includes("\n")){
        content = content.replace("\n", "")
      }
      return content+'&nbsp;';
    },
    getCatalogCoverPhoto(catalog){
      if('catalog_cover_photo_path' in catalog){
        return Utils.convertToLoginIPDomainName(catalog.catalog_cover_photo_path)
      }
      return Utils.getNoThumbnailImg();
    },
    getColorBasedOnExpiry(locationInfo){
      if(Object.keys(locationInfo).includes('aws') && Object.keys(locationInfo.aws).includes('restoration_expiry_datetime')){
        let currentDate = new Date();
        // Create the given date (replace with your desired date)
        let givenDate = new Date(locationInfo.aws.restoration_expiry_datetime);
        // Compare the dates
        if (currentDate > givenDate) {
          return 'currentColor'
        } else {
          return '#28a745'
        }
      }
      return 'currentColor'
    },
    getTraversedFolderList(){
      let traverPathList = []
      if(this.selectedComponent == "bins-display-component" && !this.showBins){
        if(this.rootPathPermission){
          let paths = this.rootPathPermission.name_path;
          paths = paths.replace("share://","");
          let pathList = paths.split("/");
          let pathIds = this.rootPathPermission.path;
          pathIds = pathIds.replace("share_id://","");
          let pathIdList = pathIds.split("/");
          for(let i = 0; i<pathList.length;i++){
            traverPathList.push({
              _id:pathIdList[i],
              file_name:pathList[i],
              permissions:this.rootPathPermission.permission
            })
          }
        }
      }else if(this.selectedComponent == 'catalogs-display-component'){
        if(this.rootPathPermission){
          let paths = this.rootPathPermission.name_path;
          paths = paths.replace("catalog://0/","");
          let pathList = paths.split("/");
          let pathIds = this.rootPathPermission.path;
          pathIds = pathIds.replace("catalog_id://0/","");
          let pathIdList = pathIds.split("/");
          for(let i = 0; i<pathList.length;i++){
            traverPathList.push({
              _id:pathIdList[i],
              file_name:pathList[i],
              permissions:this.rootPathPermission.permission
            })
          }
        }
      }
      this.folderStructure = traverPathList
      return this.folderStructure
    },
    selectAllFiles(event){
        if(event.target.checked){
          this.unselectElement();
          this.unselectAllFiles();
          for(let i = 0; i< this.filesList.files.length; i++){
            this.multiSelectElemet(this.filesList.files[i]);
            // this.isFileSelected(this.filesList.files[i])
          }
        }else{
            this.unselectElement();
            this.unselectAllFiles();
            this.deselectFileAndContextMenu();
        }
    },
    isFileSelected(fileInfo){
      if (fileInfo.file_uid && this.fileUuids.includes(fileInfo.file_uid)){
        return true
      }
    },
    replaceByDefaultImage(e,fileInfo,forsvgThumbnail = ''){
      e.target.onerror = null
       if(fileInfo && fileInfo.mime_type && fileInfo.mime_type.startsWith('audio')){
            e.target.src = Utils.getAudioWaveformSvg();
            return;
        }
        try{
          if(forsvgThumbnail && forsvgThumbnail == 'FOR_SVG_THUMBNAIL'){
            let svgInfo = Utils.determineSvgIconForType(fileInfo);
            if(!svgInfo){
               e.target.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Utils.getDefaultUnknowIcon())}`;
            }else{
               e.target.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgInfo)}`;
            }
            return;
          }
        }catch(err){console.log(err)}
      e.target.src = Utils.getNoThumbnailImg();
    },
    //preview actions
    closeMinimisedPlayer(){
      this.openPip = false;
      this.showOtherFilesPreviewDialog = false;
    },
    picPicZindex(zvalue, ref){
      this.$refs[ref].$el.style.cssText += `z-index:${zvalue} !important`
    },
    showAssetDetailsDockCloseMiniplayer(){
      if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
        this.openPip = true;
    },
    showAssetDetailsDockCloseMaximisedplayer(){
      if(this.isFullscreenPreviewAllowed()){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = true;
        return;
      }
    },
    isFullscreenPreviewAllowed(){
      let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
      return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileInfo)) > -1
    },
    openPictureInPicture(){
      if(this.isFullscreenPreviewAllowed()){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = true;
        return;
      }else{
        this.openPip = true;
        this.showOtherFilesPreviewDialog = false;
      }
    },
    //view styles
    changeViewTypes(){
      this.gridView = !this.gridView;
    },
    //Advance Search
    advancedSearchData(data){
      this.advanceSearchKeys = data;
      if(this.selectedComponent == "bins-display-component"){
        this.refreshFilesList(this.currentFolderInfo, false)
      }else{
        this.refreshCAssetsList(this.selectedCatalog, false);
      }
    },
    heightSet(){
      if(document.querySelector(".advanced-search-wrapper") != undefined){
        let height = document.querySelector(".advanced-search-wrapper").getBoundingClientRect().height;
        height = `calc(100% - ${height}px - 30px)`;
        this.resizedHeight  = height;
      }else{
        this.resizedHeight  = "94%";
      }
    },
    deselectFileAndContextMenu(event=null,hardReload=false) {
      // if clicked on contextmenu item then don't proceed further to diselect element
      try{
         if(event && event.target.closest('.v-list-item').getAttribute('role') == 'menuitem') return true;
      }catch(e){console.log(e)}
      if (hardReload){
        event = {ctrlKey: false}
      }
      if (this.dragSelected){
        this.dragSelected = false
        return
      }
      if (event){
        try{
          event.stopImmediatePropagation()
        }catch(error){
          console.log("error",error)
        }
        if (!(event.ctrlKey)){
          this.unselectAllFiles();
        }
      }
      // this.closeContextMenu();
      this.unselectElement();
    },
    // blaze doesn't mount Explorer (which loads search filters into store), so load them once config-advanced-search is rendered
    loadBlazeSearchFilters(){
      if(this.$route && this.$route.name == 'blaze_fusion_browse' && this.$refs.configAdvancedSearchRef){
        this.$refs.configAdvancedSearchRef.reloadButtonClicked();
        this.addBlazeSearchFilterListener('configAdvancedSearchRef');
      }
    },
    addBlazeSearchFilterListener(refName){
      if(this.$route && this.$route.name == 'blaze_fusion_browse' && this.$refs[refName]){
        this.$refs[refName].$el.addEventListener('focusin', this.alignBlazeSearchFilterDropdown);
        // advanced search is re-created on workspace switch, observe the new element so assets/pagination height is recalculated
        if(!this.resizeObservor){
          this.resizeObservor = new ResizeObserver(() => this.heightSet());
        }
        this.resizeObservor.observe(this.$refs[refName].$el);
        this.heightSet();
      }
    },
    removeBlazeSearchFilterListener(refName){
      if(this.$refs[refName]){
        this.$refs[refName].$el.removeEventListener('focusin', this.alignBlazeSearchFilterDropdown);
      }
    },
    // advanced search dropdowns are position:fixed with width:18% of viewport, too narrow (or off-screen) in a small iframe,
    // so place the opened dropdown right below its input with the input's width
    alignBlazeSearchFilterDropdown(event){
      let multiselectEl = event.target.closest('.multiselect');
      if(!multiselectEl) return;
      this.$nextTick(() => {
        let dropdownEl = multiselectEl.querySelector('.multiselect__content-wrapper');
        if(!dropdownEl) return;
        let rect = multiselectEl.getBoundingClientRect();
        dropdownEl.style.setProperty('left', `${rect.left}px`, 'important');
        dropdownEl.style.setProperty('top', `${rect.bottom}px`, 'important');
        dropdownEl.style.setProperty('bottom', 'auto', 'important');
        dropdownEl.style.setProperty('width', `${rect.width}px`, 'important');
      });
    },
    enableAdvancedSearchFunc(){
      this.enableAdvancedSearch = !this.enableAdvancedSearch;
      try {

        this.$nextTick(() => {
          this.resizeObservor = new ResizeObserver(() =>{
            // this.resizeObservor.disconnect();
            this.heightSet();
          });
          try {
                  this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
                } catch (error) {
                  console.log("Error to resize")
                  this.heightSet();
                }
        });
      } catch (error) {
                  console.log("Error to resize")
        this.heightSet();
      }
    },
    //catalogs display
    async setRootElement(){
      this.allFilesSelected = false
      let payload = {params:{catalog_id: Constants.rootCategory,asset_type:"catalog"}}
      let data = await this.getAllAssetsFromServer(payload);
      if (Constants.acceptedStatusCodes.includes(data.statusCode)){
        this.rootElement = data.assets[0]
        if("root_path_permissions" in data){
          this.rootPathPermission = data["root_path_permissions"];
        }
      }
    },
    initCBrowse() {
      this.folderStructure = []
      this.selectedCatalog = Object.assign({}, this.rootElement);
      let cInfo = {};
      if(Object.hasOwnProperty.call(this.selectedCatalog,'catalog_name') && this.selectedCatalog.catalog_name != 'undefined'){
          cInfo = { _id: this.selectedCatalog._id, file_name: this.selectedCatalog.catalog_name , pid: this.selectedCatalog.parent_id_path[0], catalog_name:this.selectedCatalog.catalog_name};
          this.folderStructure.push(cInfo);
      }
      this.refreshCAssetsList(cInfo, false);
    },
    switchCatalog(catalogInfo){
      this.keywordFilter = "";
      let parmsInfo={
          _id: catalogInfo._id,
          pid: catalogInfo.parent_id_path[0],
          file_name: catalogInfo.catalog_name,
          catalog_name: catalogInfo.catalog_name,
          catalog_id:catalogInfo._id,
      }
      this.refreshCAssetsList(parmsInfo, false);
    },
    deselectTraversedFolder(){
      this.fileUuids =[]
      this.unselectElement();
      this.unselectAllFiles();
      this.deselectFileAndContextMenu();
    },
    refreshCAssetsList(catalogInfo = {}, isPageClick) {
      this.allFilesSelected = false
      let payload = { params: {} };
      if(isPageClick){
        payload.params.page = this.page;
      }
      payload.params.view_type = "list";
      payload.params.sort_by= this.sortBy.sortOn;
      payload.params.sort_order= this.sortBy.ascDesc;
      payload.params.browse = true;
      if(this.supportedBrowseMimeType && this.supportedBrowseMimeType.length > 0){
        payload.params.mime_type = JSON.stringify(this.supportedBrowseMimeType)
        payload.params.asset_type = 'catalog'
      }
      
      if (Object.keys(catalogInfo).length != 0) {
        let alreadyInCatalog = false;
        for (let dir of this.folderStructure) {
          if (dir._id === catalogInfo._id) {
            alreadyInCatalog = true;
          }
        }
        if (!alreadyInCatalog) {
          if(Object.hasOwnProperty.call(catalogInfo,'catalog_name') && catalogInfo.catalog_name != 'undefined'){
              this.folderStructure.push({ 
                    _id: catalogInfo._id, 
                    file_name: catalogInfo.catalog_name,
                    pid: catalogInfo.pid, 
                    catalog_name:catalogInfo.catalog_name
              });
              if (this.selectedCatalog._id != catalogInfo._id){
                this.selectedCatalog = Object.assign({}, { 
                  _id: catalogInfo._id, 
                  file_name: catalogInfo.catalog_name,
                  pid: catalogInfo.pid, 
                  catalog_name:catalogInfo.catalog_name
                })
              }              
          }
        }
      }
      payload.params.catalog_id = this.selectedCatalog._id;
      if (this.keywordFilter && (this.keywordFilter != null && this.keywordFilter != undefined) && this.keywordFilter.length){
        payload.params.keyword = this.keywordFilter;
        delete payload.params.browse;
      }else{
        delete payload.params.keyword 
      }
      if(this.advanceSearchKeys != undefined && Object.keys(this.advanceSearchKeys).length){
          if('fields' in this.advanceSearchKeys && Object.keys(this.advanceSearchKeys.fields).length == 0){
              if(Object.keys(this.advanceSearchKeys).length > 1){
                payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
                delete payload.params.browse;
              }
          }else{
              payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
              delete payload.params.browse;
          }
        if(Object.keys(this.advanceSearchKeys).includes("fields") && Object.keys(this.advanceSearchKeys.fields).length == 0){
          delete payload.params.fields;
        }
      }
      
      let fileStateFromFilter = JSON.parse(localStorage.getItem('file-browse-file-status-filter-state'));
      if(this.assetsState && this.assetsState.state.length){
        payload.params.state = JSON.stringify(this.assetsState.state);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length){
        if(fileStateFromFilter.state && fileStateFromFilter.state.length){
          payload.params.state = JSON.stringify(fileStateFromFilter.state);
        }
      }else{
          delete payload.params.state;
      }

      if(this.assetsState && this.assetsState.filter.length > 0){
        payload.params.filter = JSON.stringify(this.assetsState.filter);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.filter && fileStateFromFilter.filter.length > 0){
          payload.params.filter = JSON.stringify(fileStateFromFilter.filter);
        }
      }else{
        delete payload.params.filter;
      }

      if(this.assetsState && this.assetsState.storage_class.length){
        payload.params.storage_class = JSON.stringify(this.assetsState.storage_class);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.storage_class && fileStateFromFilter.storage_class.length){
          payload.params.storage_class = JSON.stringify(fileStateFromFilter.storage_class);
        }
      }else{
        delete payload.params.storage_class;
      }
      if(this.enableOnlyFolders){
        payload.params["asset_type"] = "catalog"
      }
      this.getAllAssetsFromServer(payload).then((data) => {
        this.deselectTraversedFolder()
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalFiles = data["total_assets"];
        this.perPage = data["assets_per_page"]
        this.filesList = { dirs: [], files: [] }
        this.children = []
        for (const asset of data.assets) {
          if(asset.asset_type == 'catalog'){
              this.addFolder(asset,false)
            } else {
              if('asset_type' in asset && asset.asset_type == "subclip"){
                asset["file_uid"] = asset._id;
              }
              this.addFile(asset,false)
            }
          if(this.preSelectedPathIds.includes(asset._id)){
            if(this.preSelectedPathIds.length == 1){
              this.selectElement(null, asset)
            }else{
              this.multiSelectElemet(asset)
            }
          }
        }
        if("root_path_permissions" in data){
          this.rootPathPermission = data["root_path_permissions"];
        }
      });
    },
    //Component side menu
    switchWorkpace(panel){
      this.PAMBrowseSelectedMenu = null;
      this.showFolders = true;
      this.showAlbums = true;
      this.showFiles = true;
      this.binSelected = null;

      this.currentFolderInfo = {};
      this.page = 1;
      this.folderStructure =[];
      this.unselectAllFiles();
      this.unselectElement();
      this.selectedComponent = panel;
      this.allFilesSelected = false;
      if(this.selectedComponent == 'catalogs-display-component'){
        this.gridView= true;
        this.browseContext = "catalogs-display";
        this.usedByCLabel = "Catalogs";
        this.showBins = false;
        this.folderStructure.push(this.rootCategory);
        this.initCBrowse();
      }else if(this.selectedComponent == 'bins-display-component'){
        this.gridView= true;
        this.browseContext = "bins";
        this.showBins = true;
        this.usedByCLabel = "Bins"
        this.rootPathPermission = null
      }else if(this.selectedComponent == 'tickets-display-component'){
        this.pamWorkspaceType = 'Ticket'
        this.gridView = false;
        if(this.enableAdvancedSearch){
          this.enableAdvancedSearch = false;
        }
        this.browseContext = "tickets";
        this.showBins = false;
        this.usedByCLabel = "Tickets";
        this.initPAMBrowse();
      }else if(this.selectedComponent == 'tasks-display-component'){
        this.pamWorkspaceType = "Task"
        this.gridView = false;
        if(this.enableAdvancedSearch){
          this.enableAdvancedSearch = false;
        }
        this.browseContext = "tasks";
        this.showBins = false;
        this.usedByCLabel = "Tasks";
        this.initPAMBrowse();
      }else if(this.selectedComponent == 'issues-display-component'){
        this.pamWorkspaceType = "Issue"
        this.gridView = false;
        if(this.enableAdvancedSearch){
          this.enableAdvancedSearch = false;
        }
        this.browseContext = "issues";
        this.showBins = false;
        this.usedByCLabel = "Issues";
        this.initPAMBrowse();
      }
    },
    //bins display
    selectedMainComponent(comp,binsData={}){
      if(binsData != undefined && Object.keys(binsData).length > 0){
        this.keywordFilter = "";
        this.showBins = false;
        this.selectedBinId = binsData.bin_id;
        let binInfo = {
          file_name:binsData.bin_name,
          _id:"0",
          path:"share://"+binsData.bin_id,
          permission:"full-control"
        }
        this.binSelected = binsData.bin_id
        this.folderStructure.push(binInfo)
        this.clearSearchBarTextOnly(true);
        this.refreshFilesList(binInfo, false)
      }
    },
    handleSelectedRootBin(binInfoList){
      if(binInfoList){
        if(binInfoList.length >1){
          for(let op of binInfoList){
            this.multiSelectElemet(op, true)
          }
          return
        }else{
          this.selectElement(null, binInfoList[0])
        }
      }else{
        this.deselectTraversedFolder()
      }
    },
    //////////////////////////
    // global search
    clearSearchBarTextOnly(forceClear = false){
      this.keywordFilter = "";
      this.searchKeywordListFromAutocomplete = [];
      this.searchedValue = [];
      this.lastSearch = [];
      if(this.$refs.globalSearch){
      this.$refs.globalSearch.search = "";
      }
      if(!forceClear){
        this.keywordSearchParameters();
      }
      this.$nextTick(() => {
        this.resizeObservor = new ResizeObserver(() =>{
          // this.resizeObservor.disconnect();
          this.heightSet();
        });
          this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
      });
    },
    SearchKeywordOptionsOnRemoveCallback(){
      this.searchKeywordListFromAutocomplete = [];
    },
    keywordOptionsOnSelectCallback(option){
      this.keywordFilter = option;
      this.searchedValue = [];
      this.searchedValue.push(option);
      if(this.$refs.globalSearch){
      this.$refs.globalSearch.search = option;  
      }    
      this.keywordSearchParameters();
    },
    getSearchKeywordsOnKeyup(option){
      this.$nextTick(()=>{
        if(this.selectedMainComponent != 'review-display' && this.enabledComponent != 'projects-display'){
          let payload = {}
          this.searchKeywordListFromAutocomplete = [];
          if(typeof(option) != "undefined" && option.trim().length >= 2 && this.isAutoCompleteEnabled()){
            this.searchKeywordListFromAutocomplete.push(option);
            payload.params = {keyword:option};
            this.getSearchKeywordAutoComplitionFromServer(payload).then((data) => {
              let tempList = data["keywords"];
              this.searchKeywordListFromAutocomplete = this.searchKeywordListFromAutocomplete.concat(tempList.filter(ele => !this.searchKeywordListFromAutocomplete.includes(ele)));
            }); 
          }else{
            if(option == ""){
              this.searchKeywordListFromAutocomplete = [];  
            }else if(this.isAutoCompleteEnabled()){
              this.searchKeywordListFromAutocomplete = [];
              this.searchKeywordListFromAutocomplete.push(option);
            }else{
              this.keywordFilter = option
            }
          }
        }   
      });  
    },
    isAutoCompleteEnabled(){
      return JSON.parse(Utils.getLocalStorageValue('enable_auto_complete_for_assets_search'))
    },
    open() {
      this.searchedValue = this.lastSearch;
      this.$nextTick(() =>{
        if(this.$refs.globalSearch){
        this.$refs.globalSearch.$el
        .querySelector(".multiselect__input")
        .setSelectionRange(-1, -1);
        }
      });
    },
    closed() {
      let search = undefined; 
      if(this.$refs.globalSearch){
        this.$refs.globalSearch.search;
      }
      if (!search) {
        this.searchedValue = [];
        return;
      }
      this.searchedValue = [];
      this.searchedValue.push(search);
      this.lastSearch = [];
      this.lastSearch.push(search);
      this.$emit("handleFilesBrowse",[], this.activeIndexInfo.apply_recursively);
    },
    postMessageToParentBlazeWindow(cmd,key,data){
          let authentication_id = '';
          if(localStorage.getItem('sessionId') != null){
              authentication_id = String(localStorage.getItem('sessionId')).trim();
          }
           
        window.parent.postMessage({
            cmd: cmd,
            params: {
                [key]:data,
                authentication_id:authentication_id,
            }
        },"*");
    },
    handleFileSelection(){
      let filesDetails = [];
      if(Object.keys(this.selectedFileInfo).length > 0){
        filesDetails = [this.selectedFileInfo]
      }else{
        for(let key of Object.keys(this.selectedFiles)){
        filesDetails.push(this.selectedFiles[key])
        }
      }
     // if(['tickets-display-component','tasks-display-component','issues-display-component'].includes(this.selectedComponent)){
      if(this.$refs['pam-browse-ref']){
          let comp = this.$refs['pam-browse-ref'];//this.$refs.tickets_tasks_issues_component;
          if(Object.keys(comp.selectedFileInfo).length > 0){
            filesDetails = [comp.selectedFileInfo]
          }else{
            for(let key of Object.keys(comp.selectedFiles)){
               filesDetails.push(comp.selectedFiles[key])
            }
          }

          console.log("filesDetails filesDetails",filesDetails);
      }

      if(this.$route.name == 'blaze_fusion_browse' || String(window.location.href).includes('fusion-browse/blaze/files')){
          this.postMessageToParentBlazeWindow('attachMediaFiles','selected_file_info',filesDetails);
          return;
      }
      if(filesDetails && filesDetails.length > 0){
        this.$emit("handleFilesBrowse",filesDetails, this.activeIndexInfo.apply_recursively);
      }else if(this.enableOnlyFolders){
        alert("Please select path")
      } 
    },
    setAutocompleteOff(){
      if(this.$refs.globalSearch){
       this.$refs.globalSearch.$el
        .querySelector(".multiselect__input").setAttribute("autocomplete", "off");
      }
    },
    keywordSearchParameters(){
        if  (this.selectedComponent == "bins-display-component"){
          if([undefined, null].includes(this.binSelected) || this.binSelected.length <= 0){
            if(this.showBins && this.selectedComponent == "bins-display-component"){
              this.$refs.binsDisplay.filterBinsBy(this.keywordFilter)
              return
            }
            alert("Select any bin..!");
          }else{
            this.refreshFilesList(this.currentFolderInfo, false)
          }
          this.enableAdvancedSearch = true;
          this.$nextTick(() => {
            this.heightSet();
          });  
        }else if(["catalogs-display-component"].includes(this.selectedComponent)){
          this.enableAdvancedSearch = true;
          this.$nextTick(() => {
            this.heightSet();
          });
          if(this.selectedCatalog == undefined || !('_id' in this.selectedCatalog)){
            alert("Select any catalog. ");
          }else{
            this.refreshCAssetsList(this.selectedCatalog, false);
          }
        }else if(this.$refs['pam-browse-ref']){
          this.$refs['pam-browse-ref'].initPAMBrowse(false);
        }
      },
      selectionLabelCallback(option){
        return `${option}`
      },
    //////////////////////////
    // assets display
    sortBinsTable(option){
      this.sortBy = option;
      if  (this.selectedComponent == "bins-display-component"){
        localStorage.setItem("bins_sort_by_value", JSON.stringify(this.sortBy));
        this.refreshFilesList(this.currentFolderInfo, false);
      }else{
        localStorage.setItem("catalogs_sort_by_value", JSON.stringify(this.sortBy));
        this.refreshCAssetsList(this.selectedCatalog, false);
      }
    },
    changeDir(fileInfo){
      if  (this.selectedComponent == "bins-display-component"){
        this.currentFolderInfo = fileInfo;
        this.refreshFilesList(fileInfo, false);
      }
      else{
        if(fileInfo._id == this.rootElement._id){
          this.initCBrowse();
        }else{
          this.selectedCatalog = fileInfo;
          this.refreshCAssetsList(this.selectedCatalog, false);
        }
      }
    },
    isPEnabled(priv) {
      // console.log("%%%%%%%%%%%%%%%%%%%%%%%%", this.getLoggedInUserPrivilege)
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
    },
    format(date) {
      date = new Date(date);
      const day = `${date.getUTCDate()}`.padStart(2, "0");
      const month = `${date.getUTCMonth() + 1}`.padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    },
    changeComponent() {
      this.binSelected = "";
      this.showBins = true;
      this.folderStructure = []
    },
    paginate(page) {
      this.allFilesSelected = false
      this.page = page;
      if(['tickets-display-component','tasks-display-component',"issues-display-component"].includes(this.selectedComponent)){
        this.$refs.tickets_tasks_issues_component.initPAMBrowse(true);
        //this.initPAMBrowse(true);
      }else if(this.selectedComponent == "catalogs-display-component"){
        this.refreshCAssetsList(this.selectedCatalog, true);
      }else if(!this.showBins && this.binSelected){
        this.refreshFilesList(
          this.folderStructure[this.folderStructure.length - 1], true
        );
      }
    },
    formatedDate(date){
      return Utils.getDateFormat(date);
    },
    closeModal() {
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
    },
    close(){
      this.$emit('close')
    },
    getMimeType(type) {
      if(type == null){
        return "-"
      }
      let givenType = type.split("/")[0];
      if (givenType == "application") {
        givenType = "app";
      }
      return givenType;
    },
    humaniseSize(bytes) {
      let data = Utils.humanizeSize(bytes);
      return `${data["value"]} ${data["unit"]}`;
    },
    getFileName(file) {
      if(this.selectedComponent == "catalogs-display-component"){
        return file.slug_name;
      }
      if (file.file_name) {
        return file.file_name;
      } else {
        return Utils.getBaseName(file.path);
      }
    },
    selectElement(event, fileInfo) {
      // if (event != null) {
      //   event.stopImmediatePropagation();
      // }
      this.unselectAllFiles()
      this.selectedFileInfo = fileInfo;
      if (this.enableOnlyFolders || (this.allowCatalogAsAttachment || !["folder", "catalog"].includes(fileInfo.asset_type))) {
        let sFUid = fileInfo._id
        if('file_uid' in fileInfo){
          sFUid = fileInfo.file_uid
        }
        this.fileUuids.push(sFUid)
      }
    },
    multiSelectElemet(fileInfo, onlyForBinsBrowse=false){
      let temp = this.selectedFiles;
      if(!this.enableAssetMultiSelect || ((!this.allowCatalogAsAttachment && ["folder", "catalog"].includes(fileInfo.asset_type)) && !this.enableOnlyFolders)){
        return true;
      }
      let sFUid = fileInfo._id
      if('file_uid' in fileInfo){
        sFUid = fileInfo.file_uid
      }
      if(this.fileUuids.includes(sFUid)){
        this.fileUuids = this.fileUuids.filter(op=> op != sFUid);
      }else{
        this.fileUuids.push(sFUid)
      }
      if (temp[sFUid] && !onlyForBinsBrowse){
          delete temp[sFUid]
          return true;
      }
      if (Object.keys(this.selectedFileInfo).length != 0){
        temp[sFUid] = fileInfo;
        if('file_uid' in this.selectedFileInfo){
          temp[this.selectedFileInfo.file_uid] = this.selectedFileInfo;
        }else{
          temp[this.selectedFileInfo._id] = this.selectedFileInfo;
        }
      }
      // else{
        
        temp[sFUid] = fileInfo;
        this.selectedFiles = temp
        if(this.enableAssetMultiSelect){
          this.selectedFileInfo = {}
        }
      if((Object.keys(this.selectedFiles) <= 1|| Object.keys(this.selectedFileInfo).length ) && this.eOMenu){
        this.eOMenu = false;
      }
      // }
    },
    dragSelect(event){
      if (event.length<=1 || !this.enableAssetMultiSelect){
        return
      }
      if(event && event.length>= 1)
      this.unselectElement();
      let assetIdlist = [].concat(event)
      this.unselectAllFiles()
      for (const assetId of assetIdlist) {
        let fileInfo = this.getFileInfoByAssetIdFromInMem(assetId)
        if (Object.keys(fileInfo).length !=0){
          if('file_uid' in fileInfo){
            this.fileUuids.push(fileInfo.file_uid);
          }else{
            this.fileUuids.push(fileInfo._id);
          }
          this.selectedFiles[fileInfo._id] = fileInfo
          this.dragSelected = true
        }
      }
    },
    getFileInfoByAssetIdFromInMem(asset_id){
      if(this.filesList.files.length <= 0){
        return {}
      }
      let fileinfo = this.filesList.files.filter((file_)=>file_._id==asset_id);
      if(fileinfo.length != 0){
          return fileinfo[0]
      }
    
      return {}
    },
    unselectElement() {
      this.selectedFileInfo = {};
    },
    setClipBoardText(file){
      let copiedLink = ""
      if(Object.keys(file).length && "access_url" in file){
        copiedLink = file.access_url;
      }
      if(copiedLink.trim().length <= 0){
        alert("Link is not avaialble.");
      }else{
        navigator.clipboard.writeText(copiedLink);
      }
      this.eOMenu = !this.eOMenu;
    },
    showAssetDetails(file) {
      this.clearSearchBarTextOnly(true)
      this.selectElement(null, file);
      if (file.asset_type === "file") {
        this.openPictureInPicture();
      } else {
        if(this.selectedComponent == "catalogs-display-component"){
          this.selectedCatalog = file;
          this.refreshCAssetsList(this.selectedCatalog, false);
          return;
        }
        if(!this.currentFolderInfo) this.currentFolderInfo = {};
          Object.assign(this.currentFolderInfo, file);
        this.refreshFilesList(file, false)
      }
    },
    multiPAMEntrySelection(fileInfo){
      let temp = this.selectedFiles;
      if(!this.enableAssetMultiSelect){
        return true;
      }
      if(this.fileUuids.includes(fileInfo._id)){
        this.fileUuids = this.fileUuids.filter(op=> op != fileInfo._id);
      }else{
        this.fileUuids.push(fileInfo._id)
      }
      if (temp[fileInfo._id]){
          delete temp[fileInfo._id]
          return true;
      }
      if (Object.keys(this.selectedFileInfo).length != 0){
        temp[fileInfo._id] = fileInfo;
        temp[this.selectedFileInfo._id] = this.selectedFileInfo;
      }
      // else{
        temp[fileInfo._id] = fileInfo;
        this.selectedFiles = temp
        if(this.enableAssetMultiSelect){
          this.selectedFileInfo = {}
        }
      // }
    },
    selectPAMElement(event, fileInfo) {
      this.unselectAllFiles()
      this.selectedFileInfo = fileInfo;
      this.fileUuids.push(fileInfo._id)
    },
    showPAMDetails(file){
      this.selectPAMElement(null,file);
      this.viewPamEntryDetails = true;
    },
    isProxyPresent(file){
       if(typeof file.proxy_info == 'object' && file.proxy_info && file.proxy_info.thumbnail_uri) return true;
       return false;
    },
    isSubclipMarkersPresent(file){
      if(typeof file.markers == 'object' && file.markers && file.markers.frame_thumbnail_uri) return true;
       return false;
    },
    getThumbnailPath(file,forsvgThumbnail = '') {
     try{
        if(forsvgThumbnail && forsvgThumbnail == 'FOR_SVG_THUMBNAIL'){
            if(!this.isProxyPresent(file) && !this.isSubclipMarkersPresent(file)){
              let svgIcon = Utils.determineSvgIconForType(file);
              if(!svgIcon) return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Utils.getDefaultUnknowIcon())}`;
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgIcon)}`;
            }
        }
      }catch(err){console.log(err)}
      return Utils.getThumbnailPathfromFileInfo(file);
    },
    getHumanReadableDuration(duration){
      return Utils.getDurationInSeconds(duration)
    },
    is4K(fileWidth, fileHeight) {
      return fileWidth >= 3840 || fileHeight >= 3840
    },
    isFHD(fileWidth, fileHeight) {
      return fileWidth >= 1920 || fileHeight >= 1920
    },
    isHD(fileWidth, fileHeight) {
      return fileWidth >= 1280 || fileHeight >= 1280
    },
    isSD(fileWidth, fileHeight) {
      return fileWidth >= 720 || fileHeight >= 720
    },
    getReadableResolutionValue(file){
      let resKey = null
      let newClassName = null
      if('width' in file && 'height' in file){
        if(this.is4K(file.width, file.height)){
          newClassName = "res-fourK"
          resKey = "4K"
        }else if (this.isFHD(file.width, file.height)) {
          newClassName = "res-FHD"
          resKey = "FHD"
        }else if(this.isHD(file.width, file.height)){
          newClassName = "res-HD"
          resKey = "HD"
        }else if(this.isSD(file.width, file.height)){
          newClassName = "res-SD"
          resKey = "SD"
        }
        if(newClassName){
          this.$nextTick(()=>{
            let divId = "assetResolution_"+file["_id"];
            if(document.querySelector("#"+divId))document.querySelector("#"+divId).classList.add(newClassName)
          });
        }
      }
      if(!resKey && document.getElementById("assetResolution")){
        document.getElementById("assetResolution").remove()
      }
      return resKey
    },
    fileExistsinMem(file_uid, file_info_list){
      let file_info = file_info_list.filter((file_)=>file_.file_uid==file_uid)
      if (file_info.length!=0){
        return true
      }
      return false
    },
    sortFoldersByDate(){
      this.filesList.dirs.sort((first, second)=>{
              let d1 = new Date(first.modified_datetime)
              let d2 = new Date(second.modified_datetime)
              return d2-d1;
            })
    },
    sortfilesByDate(){
      this.filesList.files.sort((first, second)=>{
              let d1 = new Date(first.modified_datetime)
              let d2 = new Date(second.modified_datetime)
              return d2 - d1;
            })
    },
    addFolder(folder_info, sort_by_date=false){
      if(!this.defaultPermissions.includes(folder_info.permissions)){
        return
      }
      if (!(this.fileExistsinMem(folder_info, this.filesList.dirs))){
        this.filesList.dirs.push(folder_info);
        if (sort_by_date){
          this.sortFoldersByDate()
        }
        
      }
    },
    addFile(file_info,sort_by_date=false){
      if (!(this.fileExistsinMem(file_info, this.filesList.files))){
        this.filesList.files.push(file_info);
        if (sort_by_date){
          this.sortfilesByDate()
        }
      }
    },
    updateFolder(file, sort_by_date=false){
      let file_info = this.filesList.dirs.filter((file_)=>file_.file_uid==file.file_uid)
      if (file_info.length !=0){
        Object.assign(file_info[0], file)
        if (sort_by_date){
          this.sortFoldersByDate()
        }
      }
    },
    updateFile(file, sort_by_date=false){
      let file_info = this.filesList.files.filter((file_)=>file_.file_uid==file.file_uid)
      if (file_info.length !=0){
        if(!Object.hasOwnProperty.call(file,'permissions')) Object.assign(file,{permissions:this.currentFolderInfo.permissions});
        Object.assign(file_info[0], file);
        if (sort_by_date){
          this.sortfilesByDate()
        }
      }
    },
    removeFolder(file, sort_by_date=false){
      this.filesList.dirs = this.filesList.dirs.filter((file_)=>file_.file_uid!=file.file_uid)
      if (sort_by_date){
          this.sortFoldersByDate()
      }
    },
    removeFile(file, sort_by_date=false){
      this.filesList.files = this.filesList.files.filter((file_)=>file_.file_uid!=file.file_uid)
      if (sort_by_date){
          this.sortfilesByDate()
      }
    },
    addToFileList(file,sort_by_date=false){
      if ("file_type" in file && file.file_type === "folder") {
        let assetEntry = file;
        assetEntry["asset_type"] = "folder"
        this.addFolder(assetEntry,sort_by_date)
      } else {
        this.addFile(file,sort_by_date)
      }
    },
    updateFileList(file, sort_by_date=false){
      if (file.asset_type === "folder") {
        this.updateFolder(file,sort_by_date)
      } else {
        this.updateFile(file,sort_by_date)
      }
    },
    removeFromFileList(file, sort_by_date=false){
      if (file.asset_type === "folder") {
        this.removeFolder(file,sort_by_date)
      } else {
        this.removeFile(file,sort_by_date)
      }
    },
    updateFileStateFilter(statesArr){
      if(statesArr && Object.keys(statesArr).length){
        this.assetsState = statesArr;
      }else{
        this.assetsState = null;
      }
      if(this.selectedComponent == "bins-display-component"){
        this.refreshFilesList(this.currentFolderInfo, false)
      }else{
        this.refreshCAssetsList(this.selectedCatalog, false);
      }
    },
    refreshFilesList(fileInfo = {}, isPageClick) {
      if([null, undefined].includes(this.binSelected)){
        return
      }
      this.allFilesSelected = false
      this.showBins = false;
      let payload = { params: {} };
      if(isPageClick){
        payload.params.page = this.page;
      }
      payload.params.bin_id = `${this.binSelected}`;
      payload.params.browse = true;
      payload.params.sort_by= this.sortBy.sortOn;
      payload.params.sort_order= this.sortBy.ascDesc;
      payload.params.view_type = "list";
      if ((fileInfo != undefined || fileInfo != null) && Object.keys(fileInfo).length != 0) {
        if (!["0", this.binSelected].includes(fileInfo._id)) {
          payload.params._id = fileInfo._id;
          delete payload.params.bin_id
        }
        let alreadyInBin = false;
        for (let dir of this.folderStructure) {
          if (dir._id === fileInfo._id) {
            alreadyInBin = true;
          }
        }
        if (!alreadyInBin) {
          this.addFileinfoToFolderStructure({
            _id: fileInfo._id,
            file_name: this.getFileName(fileInfo),
            permissions: fileInfo.permissions,
          });
        }
      }
      if (this.keywordFilter && this.keywordFilter != undefined && this.keywordFilter.length){
        payload.params.keyword = this.keywordFilter;
        delete payload.params.browse;
      }else{
        delete payload.params.keyword;
      }
      if(this.advanceSearchKeys != undefined && Object.keys(this.advanceSearchKeys).length){
          if('fields' in this.advanceSearchKeys && Object.keys(this.advanceSearchKeys.fields).length == 0){
              if(Object.keys(this.advanceSearchKeys).length > 1){
                payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
                delete payload.params.browse;
              }
          }else{
              payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
              delete payload.params.browse;
          }
        if(Object.keys(this.advanceSearchKeys).includes("fields") && Object.keys(this.advanceSearchKeys.fields).length == 0){
          delete payload.params.fields;
        }
      }

      let fileStateFromFilter = JSON.parse(localStorage.getItem('file-browse-file-status-filter-state'));
      if(this.assetsState && this.assetsState.state.length){
        payload.params.state = JSON.stringify(this.assetsState.state);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length){
        if(fileStateFromFilter.state && fileStateFromFilter.state.length){
          payload.params.state = JSON.stringify(fileStateFromFilter.state);
        }
      }else{
          delete payload.params.state;
      }

      if(this.assetsState && this.assetsState.storage_class.length){
        payload.params.storage_class = JSON.stringify(this.assetsState.storage_class);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.storage_class && fileStateFromFilter.storage_class.length){
          payload.params.storage_class = JSON.stringify(fileStateFromFilter.storage_class);
        }
      }else{
        delete payload.params.storage_class;
      }

      if(this.assetsState && this.assetsState.filter.length > 0){
        payload.params.filter = JSON.stringify(this.assetsState.filter);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.filter && fileStateFromFilter.filter.length > 0){
          payload.params.filter = JSON.stringify(fileStateFromFilter.filter);
        }
      }else{
        delete payload.params.filter;
      }

      if(this.enableOnlyFolders){
        payload.params["file_type"] = "folder"
      }
      this.getAllFilesFromServer(payload).then((data) => {
        this.deselectTraversedFolder()
        if (!Utils.isAcceptedStatusCode(data.statusCode)) {
          this.filesList = { dirs: [], files: [] };
          return;
        }
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalFiles = data["total_assets"];
        this.perPage = data["assets_per_page"];
        this.filesList = { dirs: [], files: [] };
        this.unselectElement();
        this.unselectAllFiles()
        for (let file of data["files"]) {
          this.addToFileList(file)
          if(this.preSelectedPathIds.includes(file._id) || this.preSelectedPathIds.includes(file.path)){
            if(this.preSelectedPathIds.length == 1){
              this.selectElement(null, file)
            }else{
              this.multiSelectElemet(file)
            }
          }
        }
        this.showBins = false;
        if(this.filesList.dirs.length > 0){
          this.showFolders = true;
          this.showAlbums = true;
        }else{
          this.showFolders = false;
          this.showAlbums =false;
        }
        if("root_path_permissions" in data){
          this.rootPathPermission = data["root_path_permissions"];
        }
      });
    },
    initBrowse() {
      let fileInfo = {
        _id: "0",
        file_name: this.binSelected,
        permissions: "full-control",
      };
      this.addFileinfoToFolderStructure(fileInfo);
    },
    addFileinfoToFolderStructure(fileInfo){
      let file_found = this.folderStructure.filter((info)=>info._id==fileInfo._id)
      if (file_found.length ==0){
        this.folderStructure.push(fileInfo)
      }
    },
    unselectAllFiles(){
      this.selectedFiles = {}
      this.fileUuids = []
      this.dragSelected = false
    },
    getMediaTypeIcons(item) {
      if (item.startsWith("audio")) return Utils.getAudioPlayIcon();
      if (item.startsWith("video")) return Utils.getVideoPlayIcon();
    },
    getSvgIconsOfMediaTypes(path, type) {
      return Utils.determineSvgIconForType(path, type);
    },
    getBinAccessRight() {
      return this.getLoggedInUserAccessControl.bins.filter(
        (binAccessRight) =>
          binAccessRight.bin_id == this.binSelected &&
          binAccessRight.path == `share://${this.binSelected}`
      );
    },
    updateProxyForPath(notification){
      if(notification.message){
        let path = notification.message.path
        let fileinfo = this.filesList.files.filter((file_)=>file_.path==path);
        if(fileinfo.length != 0){
          this.refreshFilesList(this.currentFolderInfo, false)
        }
      }
    },
    isFolderExists(folderPath){
      let folderinfo = this.filesList.dirs.filter((file_)=>file_.path==folderPath);
      if(folderinfo.length != 0){
        return true
      }
      return false
    },
    handleAssetCreatedNotificaton(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let file_info = notification.message;
        if("master_asset_id" in file_info && file_info.master_asset_id != null){
          let file_exists = this.filesList.files.filter((file_)=>file_.asset_id==file_info.master_asset_id)
          if(file_exists.length > 0){
              file_exists[0].subclips_present = true;
          }
        }
    },
    handleBinRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let bin_info = notification.message
        if (notification.message_type == NotifierConstants.binRemovedNotification){
          if(bin_info.bin_id == this.selectedBinId){
            this.$toast.info("Selected bin is deleted by other user")
          }
        }
      }
    },
    handleFileCreateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let parent_path = notification.message.parent_path
        let add_to_list = false
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            add_to_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          add_to_list = true
        }
        if (add_to_list){
          this.addToFileList(notification.message, true)
        }
      }
    },
    handleFileUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let parent_path = notification.message.parent_path
        let update_to_list = false
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            update_to_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          update_to_list = true
        }
        if (update_to_list){
          this.updateFileList(notification.message, true)
        }
      }
    },
    handleAssetRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if("master_asset_have_subclips" in notification.message && "master_asset_id" in notification.message){
        let asset_id_check = this.filesList.files.filter((asset)=>asset.asset_id==notification.message.master_asset_id)
        if(asset_id_check.length > 0){
              if(notification.message.master_asset_have_subclips == false)
                asset_id_check[0].subclips_present = false;
          }
        }
    },
    handleFileRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let parent_path = notification.message.parent_path
        let remove_from_list = false
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            remove_from_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          remove_from_list = true
        }
        if (remove_from_list){
          this.removeFromFileList(notification.message, true)
        }
      }
    },
    handleFileArchivedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let job_info = notification.message
      let job = this.filesList.files.filter((job_)=>job_.path == job_info.path);
      if (job.length != 0){
        job = job[0];
        job.storage_class = job_info.storage_class;
      }
    },
    //PAM algorithm
    getProfileImageOfUser(image){
      let defaultImage = Utils.getNoThumbnailImg()
        let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
      return profileImageTag;
    },
    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    formatedDateField(date){
      return Utils.getOnlyDateFormat(date);
    },
    formatDateAndTime(date){
      return Utils.getDateAndTimeFormat(date);
    },
    initPAMBrowse(isPageClick = false){
      let payload = {params:{task_type:this.pamWorkspaceType}}
      if(isPageClick){
        payload.params.page = this.page
      }if(![undefined, null].includes(this.selectedProject) && this.selectedProject._id != "All"){
        payload.params.project_id = this.selectedProject._id;
      }
      if(![undefined,null].includes(this.createdByUserId) && this.createdByUserId.length>0){
        payload.params.created_by_id = this.createdByUserId
      }
      if(![undefined,null].includes(this.assigneeUserId) && this.assigneeUserId.length>0){
        payload.params.users = JSON.stringify(this.assigneeUserId)
      }
      if(![undefined,null].includes(this.selectedPAMPriority) && this.selectedPAMPriority != 'All'){
        payload.params.priority = this.selectedPAMPriority
      }
      if(![undefined,null].includes(this.selectedPAMStatus) && this.selectedPAMStatus != 'All'){
        payload.params.status = this.selectedPAMStatus;
      }
      if (![undefined,null].includes(this.keywordFilter) && this.keywordFilter.length){
        payload.params.keyword = this.keywordFilter;
      }
      this.filesList = { dirs: [], files: [] }
      this.getServerTicketsData(payload).then((data) =>{
        this.filesList["files"] = data["tasks"];
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalFiles = data["total_tasks"];
        this.perPage = data["tasks_per_page"]
      });    
    },
    getPriorityIcon(priority){
            let priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill:"#f7ab00" stroke="#f7ab00"/>
                                </svg>`;
            if(priority == "Highest"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb3a0e" stroke="#fb3a0e"/>
                                    </svg>`;
            }else if(priority == "High"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb572f" stroke="#fb572f"/>
                                    </svg>`;
            }else if(priority == "Medium"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill:"#f7ab00" stroke="#f7ab00"/>
                                    </svg>`;
            }else if(priority == "Low"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"  stroke="#b5b5b5">
                                        <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                                    </svg>`;   
            }else if(priority == "Lowest"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16" stroke="#808080">
                                        <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                                    </svg>`;   
            }

            return priorityIcon;
    },
    getStatusIcon(status){
            // let statusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
            //                     <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            //                 </svg>`;

            let statusIcon = "New";
            if(status == "In Progress"){
                statusIcon = `<svg data-v-976a8266="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" viewBox="0 0 16 16" class="bi bi-clock-fill"><path data-v-976a8266="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path></svg>`;
                
            }else if(status == "Done"){
                statusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#57af57" viewBox="0 0 16 16" class="bi bi-check-circle-fill"><path data-v-976a8266="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path></svg>`;
            }

            return statusIcon;
    },
    getProjectOptionsList(recallList){
      this.getServerProjectsData().then((data) =>{
        // if(Utils.isAcceptedStatusCode(data.status)){
          this.allProjectsList= data.projects;
          if(!(["tasks-display-component","issues-display-component"].includes(this.selectedComponent))){
            this.allProjectsList.unshift({"project_name":"All", "short_code":"All","_id":"All"});
          }
          // if(![undefined, null].includes(JSON.parse(localStorage.getItem('selected_project_obj'))){
          //   this.selectedProject = JSON.parse(localStorage.getItem('selected_project_obj')
          // }else{
            this.selectedProject = this.allProjectsList[0];
          //   localStorage.setItem("selected_project_obj", JSON.stringify(this.selectedProject)).projects;
          // }
          if(recallList){
            this.initPAMBrowse(true)
          }
        // }  
      });    
    },
    onProjectChangeOnFilter(option){
      this.selectedProject = option;
      this.initPAMBrowse(false);
    },
    handleCreatedByUsersList(user){
      if(user._id == 'all'){
        this.createdByUserId = "";
      }else if(this.createdByUserId != user._id){
        this.createdByUserId = user._id;
      }
      this.initPAMBrowse(false);
    },
    handleCreatedByRemovedUserFromList(user){
      if(this.createdByUserId == user._id){
        this.createdByUserId = ""
      }
      this.initPAMBrowse(false);
    },
    handleAssigneeUsersList(userId){
      if(userId == 'all'){
        this.assigneeUserId =[]
      }
      else if(!this.assigneeUserId.includes(userId)){
        this.assigneeUserId.push(userId);
      }
      this.initPAMBrowse(false);
    },
    handleAssigneeRemovedUserFromList(user){
      if(this.assigneeUserId.includes(user._id)){
        this.assigneeUserId.splice(this.assigneeUserId.indexOf(user._id), 1)
      }
      this.initPAMBrowse(false);
    },
    onPAMPriorityChange(option){
      this.selectedPAMPriority = option;
      this.initPAMBrowse(false);  
    },
    onPAMStatusChange(option){
      this.selectedPAMStatus = option;
      this.initPAMBrowse(false);  
    },

    getPrefferedUserTypes(){
        if(['SystemAdmin','SystemUser'].includes(this.getLoggedInUserType())){
            return ['SystemAdmin','SystemUser'];
        }
        return [];
    },

    checkIfDisabled(file){
      console.log("checkIfDisabled ********************* ", file )
      if('mime_type' in file && file.mime_type.startsWith('image')){
        if(this.getStartUpDataFromInCache() && this.getStartUpDataFromInCache().disable_resolution_display_for_image){
          return false;
        }
      }
      if('mime_type' in file && file.mime_type.startsWith('video')){
        if(this.getStartUpDataFromInCache() && this.getStartUpDataFromInCache().disable_resolution_display_for_video){
          return false;
        }
      }
      return true;
    },

    registertoWSListener(){
      this.addWSEventListener({eventname:NotifierConstants.fileCreatedNotification, callback:this.handleFileCreateNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileRemovedNotification, callback:this.handleFileRemovedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.binRemovedNotification, callback:this.handleBinRemovedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleFileArchivedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.assetCreatedNotification, callback:this.handleAssetCreatedNotificaton,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.assetRemovedCreatedNotification, callback:this.handleAssetRemovedNotification,parent:"BinsBrowse"})
    },
    ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
    ...mapActions("assets", ["getAllAssetsFromServer", "getAssetInfoFromServer"]),
    ...mapMutations("categories", ["setSelectedCategoryInCategoryBrowse"]),
    ...mapActions("files", ["getAllFilesFromServer","getSearchKeywordAutoComplitionFromServer"]),
    ...mapMutations("bins",["setSelectedPath","setPermissionOfSelectedBin"]),
    ...mapMutations("websocket",["addWSEventListener"]),
    ...mapActions("PAM", ["getServerTicketsData", "getServerIndTaskData","getServerProjectsData"]),
    ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserType"]),
    ...mapGetters("registry",["getpamBrowsePluginsList"]),
  },
  async created() {
    try{
        // register browse list pluginsn , for click and 
      for(let i = 0; i < this.getpamBrowsePluginsList().length; i++){
          let pluginInfo = this.getpamBrowsePluginsList()[i];
          console.log("pluginInfo pluginInfo",pluginInfo,pluginInfo.evalCondition(this));
          if(pluginInfo.evalCondition(this)){
            let comp = await Utils.loadPluginBundles([pluginInfo.pluginBundle.js],pluginInfo.pluginBundle.eventName);
            console.log(",,,,,,,,,,,,,,, comp",comp);
            Utils.loadCssBundle({id:pluginInfo.pluginBundle.css.id,cssUrl:pluginInfo.pluginBundle.css.cssUrl});
            this.browsePlugins.push({...pluginInfo,component:comp[0].components});
          }
          if (typeof pluginInfo.setBrowseComponent === 'function') {
            pluginInfo.setBrowseComponent(this);
          }
      }
    }catch(e){console.log(e)}
    if(this.allowedPermissions && this.allowedPermissions.length > 0){
      this.defaultPermissions = this.allowedPermissions
    }
    let ccLoaded = false;
    //if(this.parentPreSelectedPathIds){
      //this.preSelectedPathIds = this.parentPreSelectedPathIds
    //}
    if(this.browseOnlyFolders){
      this.enableOnlyFolders = this.browseOnlyFolders
    }
    if(this.workspaceList.length == 1){
      this.resizeAssetsWidth = "100%";
    }else{
      this.resizeAssetsWidth = "94%";
    }
    if(this.workspaceList.includes(Constants.WORKSPACE_CATALOG) && this.isPEnabled("catalogs-workspace")){
      this.vWorkspace[Constants.WORKSPACE_CATALOG] = true;
      this.browseContext = "catalogs-display";
      
      const savedSortBy = localStorage.getItem("catalogs_sort_by_value");
      if (savedSortBy) {
        try {
          this.sortBy = JSON.parse(savedSortBy);
        } catch (error) {
          console.error("Invalid catalogs_sort_by_value in localStorage", error);
        }
      }

      ccLoaded = true;
      this.selectedComponent = "catalogs-display-component";
      this.usedByCLabel = "Catalogs";
      this.setRootElement().then(()=>{
        this.initCBrowse();
      });
    }else{
      this.vWorkspace[Constants.WORKSPACE_CATALOG] = false;
    }
    if(this.workspaceList.includes(Constants.WORKSPACE_BINS) && this.isPEnabled("bins-workspace")){
      this.vWorkspace[Constants.WORKSPACE_BINS] = true;
      
      const savedSortBy = localStorage.getItem("bins_sort_by_value");
      if (savedSortBy) {
        try {
          this.sortBy = JSON.parse(savedSortBy);
        } catch (error) {
          console.error("Invalid bins_sort_by_value in localStorage", error);
        }
      }

      if(!ccLoaded){
        ccLoaded = true;
        this.selectedComponent = "bins-display-component";
        this.usedByCLabel = "Bins";
        this.browseContext = "bins";
      }
    }else{
      this.vWorkspace[Constants.WORKSPACE_BINS] = false;
    }
    if(this.workspaceList.includes(Constants.WORKSPACE_TICKETS) && this.isPEnabled("Ticket")){
      this.vWorkspace[Constants.WORKSPACE_TICKETS] = true;
      if(!ccLoaded){
        let p = this.browsePlugins.find((plugin)=> plugin.id == 'tickets');
        this.PAMBrowseSelectedComponent = p;
        this.PAMBrowseSelectedMenu = p.id;
        this.selectedComponent = null;
        // this.pamWorkspaceType = 'Ticket';
        // this.browseContext = "tickets";
        // ccLoaded = true;
        // this.selectedComponent = "tickets-display-component";
        // this.getProjectOptionsList(true);
      }
    }else{
      this.vWorkspace[Constants.WORKSPACE_TICKETS] = false;
    }
    
    if(this.workspaceList.includes(Constants.WORKSPACE_TASKS) && this.isPEnabled("Projects")){
      this.vWorkspace[Constants.WORKSPACE_TASKS] = true;
      if(!ccLoaded){
        /*
        this.pamWorkspaceType = "Task"
        this.browseContext = "tasks";
        ccLoaded = true;
        this.selectedComponent = "tasks-display-component";
        */
        let p = this.browsePlugins.find((plugin)=> plugin.id == 'tasks');
        this.PAMBrowseSelectedComponent = p;
        this.PAMBrowseSelectedMenu = p.id;
        this.selectedComponent = null;
        //this.getProjectOptionsList(true);
      }
    }else{
      this.vWorkspace[Constants.WORKSPACE_TASKS] = false;
    }
    
    if(this.workspaceList.includes(Constants.WORKSPACE_ISSUES) && this.isPEnabled("Projects")){
      this.vWorkspace[Constants.WORKSPACE_ISSUES] = true;
      if(!ccLoaded){
        /*
        this.pamWorkspaceType = "Issue"
        this.browseContext = "issues";
        ccLoaded = true;
        this.selectedComponent = "issues-display-component";
        */

        let p = this.browsePlugins.find((plugin)=> plugin.id == 'issues');
        this.PAMBrowseSelectedComponent = p;
        this.PAMBrowseSelectedMenu = p.id;
        this.selectedComponent = null;
         
        //this.getProjectOptionsList(true);
      }
    }else{
      this.vWorkspace[Constants.WORKSPACE_ISSUES] = false;
    }

    // if(this.vWorkspace['catalog']){
    // }else if(this.vWorkspace['bins']){
    // }
    this.registertoWSListener()
  },
  mounted() {
        const style = document.createElement('style');
        style.textContent = `.mx-datepicker-popup { z-index: 99999 !important; }`;
        document.head.appendChild(style);
  },
  beforeDestroy() {
    this.isdestroyed = true;
    if(this.resizeObservor)this.resizeObservor.disconnect();
  },
  props: ["enableAssetMultiSelect", "workspaceList", "customModelTitle","browseOnlyFolders","enableRecursive","parentPreSelectedPathIds","allowedPermissions", "supportedBrowseMimeType", "allowCatalogAsAttachment"],
  data() {
    return {
      selectedPAMStatus:'All',
      reviewStatusList:["All", "New", "In Progress", "Done",],
      selectedPAMPriority:'All',
      reviewPriorityList:["All", "Highest", "High", "Medium", "Low", "Lowest"],
      assigneeUserId:[],
      createdByUserId:"",
      selectedProject:{},
      allProjectsList:[],
      viewPamEntryDetails:false,
      vWorkspace:{},
      vCWorkspace:false,
      vBWorkspace:false,
      eOMenu:false,
      selectedCatalog:{},
      rootElement:{},
      showOtherFilesPreviewDialog:false,
      openPip:false,
      gridView:true,
      enableAdvancedSearch:false,
      browseContext:'',
      pamWorkspaceType:"",
      resizeObservor:null,
      resizedHeight:"94%",
      resizeAssetsWidth:"94%",
      advanceSearchKeys:null,
      selectedBinId:"",
      rootPathPermission:null,
      showCatalogs:true,
      lastSearch:[],
      searchedValue:[],
      keywordFilter:[],
      searchKeywordListFromAutocomplete:[],
      selectedComponent:"",
      logo: Utils.getLogo(),
      usedByCLabel:"",
      showBins: true,
      isdestroyed: false,
      filesList: { dirs: [], files: [] },
      binSelected: null,
      page: 1,
      selected: [],
      totalPages: -1,
      totalFiles: -1,
      perPage: -1,
      folderStructure: [],
      currentFolderInfo: {},
      selectedFileInfo: {},
      selectedExternalPluginInfo: {},
      options: { chunk: 5 },
      growingFileGif: Utils.getLoadingGif(),
      markForDeleteIcn: Utils.getMarkForDeleteIcon(),
      selectedFiles:{},
      dragSelected:false,
      fileUuids:[],
      sortBy:{label:'Relevance',sortOn:'added_datetime',ascDesc:-1},
      showFolders:true,
      showAlbums: true,
      showFiles:true,
      showPackages: true,
      allFilesSelected:false,
      enableOnlyFolders: false,
      activeIndexInfo:{
          "path":"",
          "apply_recursively":false
        },
      preSelectedPathIds:[],
      defaultPermissions:["full-control","read-modify","read-write","read"],
      browsePlugins: [],
      componentRefs:null,
      PAMBrowseSelectedComponent:null,
      PAMBrowseSelectedMenu:null,
    };
  },
};
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $secondary-border-color: 1px solid #2b2b2b;
  $icon-hover:#2c3339;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555; 
  $input-field-padding:.375rem 10px;
  $filter-border-color: #5a5a5a;
  $filter-bg-color: #2a2a2a;
  $row-border-color: #212121;
  @import '~vue2-datepicker/scss/index.scss';


.activeAsset,.activeMultipleAssets {
  border: 2px solid #037afb !important;
  border-radius: 5px !important;
  .thumbnail-data {
    background: #1879e28c !important;
    position: relative;
    width: 102%;
    inset-inline-start: -4px;
    .svg-icons-display {
      inset-inline-end: 0px;
      bottom: -1px;
    }
  }
}

.activeAsset.active-list-view {
  color: $active-blue;
  border: none !important;
}
// .thumbnail-view-ul{
//   li:hover{
//     border: $border-color;
//     border-radius: 5px;
//   }
// }
.thumbnail-view-ul {
  list-style-type: none;
  display: inline-flex;
  flex-wrap: wrap;
  padding: 0px;
  margin-top: 0px;
  width: 100%;
  padding-inline-start: 20px;
  justify-content: start;
  overflow: auto;
  height: auto;
  // position:relative; 
  li {
    display: inline-block;
    margin-inline-end: 10px;
    width: 174px;
    padding-inline-start: 5px;
    margin-top: 5px;
    height: 128px;
    .asset-thumbnail {
      height: 93px;
      width: 160px;
      border-radius: 7px;
      margin-top: 8px;
     // border: $border-color;
      position:relative;
      .thumbnail-view{
        height:100%;
        position: relative;
        align-items: center;
        display: inline-flex;
        justify-content:center;
        img{
          max-width: 100%;
          max-height: 100%;
          border-radius: 7px;
          object-fit: contain;
          border-radius: 7px;
        }
      }
    }
    .thumbnail-data {
      text-align: center !important;
    }
  }
}
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
.folder-view-ul {
  padding-top: 4px;
  margin-bottom: 4px;
  .folder-view-li {
    display: inline-flex !important;
    height: 46px !important;
    border: $border-color;
    border-radius: 6px;
    .folder-view {
      font-size: 30px;
    }
    .folder-data {
      margin-top: 15px;
      margin-inline-start: 7px;
      width: 118px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
    }
  }
}

.activeFolder {
  border: 1px solid $active-blue !important;
  color: $active-blue !important;
  .folder-view {
    svg {
      color: $active-blue !important;
    }
  }
}

.assets-view-wrapper {
  height: calc(100% - 130px) !important;
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
  width: 100%;
}

.assets-view-wrapper.fusion-inside-iframe-plugin{
  height: calc(100% - 160px) !important;
}

.list-view-wrapper {
  height:calc(100% - 50px) !important;
  overflow: auto;
  display: inline-block;
  width: 100%;
  li{
    margin:0px 5px ;
  }
}

.storage-type-icons-wrapper,.storage-type-icons-wrapper-list-view{
  position: absolute;
  svg,img{
    margin:3px;
  }
}

@mixin storage-image-styles {
  height: 18px !important;
  width: 16px !important;
  border-radius: 5px !important;
  object-fit: contain;
  margin: 3px;
}

.storage-type-icons-wrapper-list-view{
  color: $dull-text-color;
  inset-inline-end: 0px;
  display: flex;
  img{
    @include storage-image-styles;
  }
}
.storage-type-icons-wrapper{
  color: #999;
  background: #1a1a1ab3;
  min-width: 30px;
  width: auto;
  inset-inline-end: -2px;
  bottom: -2px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 4px;
  display:flex;
  justify-content: center;
  img{
    @include storage-image-styles;
  }
  svg{
    margin:3px;
  }
}
.shortcut-actions-type-icons-wrapper{
        visibility: hidden;
        color: #999;
        background: #000000c9;
        min-width: 30px;
        width: auto;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        position: absolute;
        top: 6px;
        inset-inline-end: 6px;
        line-height: 1;
        margin-inline-start: 8px;
        border: unset;
        --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
        box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
        display: flex;
        padding: 2px;
        border-radius: 0.375em;
        svg{
            margin-inline-start: 6px;
            margin-inline-end: 6px;
        }
    }
    .asset-thumbnail:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
        }
    }
    .overflow-parent-div {
      .overflow-menu{
        background: #1e1e1e;
        font-size: 14px !important;
        height: 24px;
        border: 1px solid #757575;
        top: 19px;
        display: inline-block;
        inset-inline-start: calc(100% - 25px);
        padding-top: 3px !important;
        // visibility: hidden;
      }
    }
    .thumbnail-hw-set:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
        }
    }
    .shortcut-actions-type-icons-wrapper svg:hover{
        fill: #fdfff4;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action:hover{
        color: #fdfff4;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action{
        color: #a3adad;
    }
.clear-icon{
  fill: #a1a1a1 !important;
  position:absolute;
  inset-inline-end:38px;
  bottom:12px;
  z-index:111;
}
  //   .dropdown-menu{
  //     background-color:#202020 !important;
  //     border: $border-color;
  //     .dropdown-item{
  //     color:$text-color;
  //     font-size:14px !important; 
  //     }
  // }

  .dropdown-item:hover{
      background-color:$bg-color-on-hover !important;
      color: $text-color !important;
  }
  .nav-item{
      color: $dull-text-color !important;
  }

  .dropdown-toggle:after{
    display:none !important;
  }
.search-icon{
  fill: #a1a1a1;
  position:absolute;
  inset-inline-end: 10px;
  bottom:12px;
  z-index:111
}
.slider-icon{
    fill: #a1a1a1;
    position: absolute;
    bottom: 12px;
  }
// blaze fusion browse (can be loaded inside an iframe with small widths)
.blaze-fusion-browse-top-0{
  .fusion-browse-search-wrapper{
    align-items: center;
  }
  .fusion-browse-search-input{
    width: auto !important;
    flex: 1 1 auto;
    min-width: 0;
  }
  .fusion-browse-search-icon-slot{
    width: auto !important;
    flex: 0 0 36px;
  }
  .slider-icon{
    position: static;
  }
  .search-icon, .clear-icon{
    bottom: 11px;
  }
  .search-bar-autocomplete-wrapper .search-bar{
    border: none !important; // inner .multiselect__tags already draws the border
    height: 38px !important; // match .multiselect__tags height so search/clear icons are vertically centered
    min-height: 38px !important;
  }
  // limit advanced search filters height, scroll vertically when there are more filters
  .blaze-advanced-search ::v-deep .selected-filters-wrapper{
    max-height: 120px;
    overflow-y: auto;
  }
  @media (max-width: 576px){
    .fusion-browse-search-wrapper{
      width: 100% !important;
    }
  }
}
.slider-icon:hover, .search-icon:hover, .clear-icon{
    fill: #fff;
  }

// //pagination
::v-deep {
  [v-cloak] .hide-picture{
    display: none;
  }
  [v-cloak] .hide-element-util-mount{ //sometimes un-necessary preview dialog was showing to hide code is required
    display: none;
    }
    .hide{
        display:none;
    }
  .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-start;
    display: none;
    margin-inline-start: 5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    min-width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 54px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 54px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 200px !important;
    z-index: 9 !important;
  }

 // for multiselect
  div[data-drag-box-component]{
      z-index:3000;
  }
  
    .search-bar-autocomplete-wrapper{
      .multiselect__content-wrapper{
        display:none;
      }
      .multiselect__tag {
        background-color: $primary-background !important;
      }
      .multiselect__tags{
          background: $primary-background !important;
          border: $border-color !important;
      }
      .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
      .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 23px;
      }
      .multiselect *{
          font-size: $input-field-and-label-font-size !important;
          font-family: "Roboto", Arial, sans-serif !important;
      }
      .multiselect__placeholder {
        padding-top: 0px;
        padding-inline-start: 5px !important;
      }
      .multiselect{
        color:$text-color !important;
        font-size: $input-field-and-label-font-size !important;
        width:100%;
        min-height: 42px !important;
        height: 42px !important;
        margin:0px !important;
        padding: 0px !important;
        border: 1px solid #4a4a4a;
      }
      .multiselect__option--selected{
          background: $bg-color-on-hover !important;
          color: $text-color;
      }
      .multiselect__content-wrapper{
          border: 1px solid $bg-color-on-hover !important;
          position: relative;
          display: block;
          background: #333 !important;
          width: 100%;
          max-height: 240px;
          overflow: auto;
          border: 1px solid $text-color;
          border-top: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          z-index: 50;
          -webkit-overflow-scrolling: touch;
      }
      .multiselect__select,.multiselect__current,.multiselect__option{
          line-height: 12px !important;
      }
      .multiselect__select{
        display: none !important;
      }
      .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
      }
      .multiselect__tags {
          background: $primary-background!important;
          height: $input-field-height;
          min-height: 38px;
      }
    }
}
    .sidenav{
      height: calc(100vh - 65px);
      border-top: none;
      padding:0px;
      .sidebar{
        background: $secondary-background-color;
        color: $secondary-text-color;
        height:70px;
        padding-top: 13px !important;
        border-radius: 10px;
      }
      .sidebar:hover{
        color: $text-color;
        background: $primary-background !important;
      }
    }

  .sidebar-main{
    background: $secondary-background-color;
  }
 .search-bar{
    // border:$border-color !important;
    background: $primary-background !important;
    width:100%;
    height:30px;
    margin-inline-start:2%;
    pointer-events: all;
    color: $text-color !important;
    padding-inline-start: 14px;
  }
  .activePanel{
    color:$active-blue !important;
    background: $primary-background !important;
    svg{
      color:$active-blue !important;
      fill:$active-blue !important;
    }
  }

.icon-background-on-hover:hover{
  background: #d1d2d31a;
}

.icon-background-on-hover{
  padding: 6px;
  height: 28px;
  width: 28px;
  border-radius: 4px;
}

.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  margin: 0px 15px;
  thead {
    color: $dull-text-color !important;
    position: relative;
    width: 100%;
    th {
      position: sticky;
      top: 0;
      background: $primary-background;
      z-index: 9;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr {
      height: 60px;
    }
  }
}

.table {
  th {
    border-top: none !important;
  }
  td {
    border-top: none !important;
  }
}

.table-with-border {
  thead {
    border-bottom: $border-color;
  }
  tr {
    border-bottom: $border-color;
  }
}

.thumbnail-hw-set {
  height: 68px;
  width: 120px;
  border-radius: 93%;
  img {
    height: 100%;
    width: 100%;
    border-radius: 7px;
  }
}

input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block;
  width: 22px;
  height: 21px;
  margin-top: -1px;
  margin-inline-start: -1px;
  border: $border-color;
  border-radius: 0.25em;
  background: $primary-background;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.thumbnail-data {
  svg {
    border-radius: 5px;
    height: 100%;
    width: 100%;
  }
}

.reduce-opacity{
  opacity: 0.67
}

.svg-icons-display {
  height: 20px;
  width: 20px;
  position: relative;
  opacity: 0.8;
  inset-inline-end: 5px;
}

.file-name {
  white-space: nowrap;
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: initial;
  position: relative;
  inset-inline-start: 2px;
  top: 2px;
}

.file-name-display-styles-in-list-view{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: initial;
    position: absolute;
    inset-inline-start: 21px;
    top: 2px;
    width:80%;
}
.modal-dialog {
    max-width: calc(100% - 90px) !important;
    width: calc(100% - 86px) !important;
    height: 90%;
    margin: 0;
    padding: 0;
  }

  .blaze-fusion-browse{
     width: 100% !important;
     max-width:100% !important;
     height:100%;
  }

  .blaze-fusion-browse-top-0{
     top: 0 !important;
  }

  .blaze-fusion-browse-full-height{
     height:  100% !important;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      user-select: text !important; 
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 2%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    width: 25%;
    z-index: 9999;
    justify-content: flex-end;
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}
.primary-btn-style button:disabled {
  color: gray;
  border: 1px solid gray;
}
.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.nav-item{
    color: $dull-text-color !important;
}

.active{
    background: $primary-background !important;
    color: #bbb !important;
}
.top-nav-bar{
  text-align: center;
    background: $secondary-background-color;
}
.table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        margin: 0px 15px;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: 0;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 45px;
            }
            tr:hover{
                background: $bg-color-on-hover;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:0 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }
    
    .user-name-or-image{
        height: 30px;
        width: 30px;
        min-width:30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }    

    .user-name{
        margin-inline-end: 10px;
        position: relative;
        bottom: 7px;
    }
    .user-name-align{
        text-align: start;
        word-break: break-word;
    }

    svg.svg-icon {
        width: 20px;
        height: 20px;
    }
    .comm-more-users-style{
        font-size: 12px!important;
        color: #000;
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        display: inline-block;
        background: $bg-color-on-hover;
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
  
    .config-value {
        margin-inline-start: 4px;
        width: 99% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }
    .show-delete-icon:hover{
        .parent-comment-delete, .parent-comment-view{
            visibility: visible;
        }
    }

    .parent-comment-delete, .parent-comment-view{
        margin-inline-start: 10px;
        position: absolute;
        inset-inline-end: 0px;
        z-index: 1;
        background: #525252;
        border: 1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 0px 5px 5px 0px;
        visibility: hidden;
    }

    .parent-comment-view{
        inset-inline-end:54px;
        border-radius: 5px 0px 0px 5px;
    }
    .comm-tag-title-hover:hover{
        text-decoration: underline;
    }

    ::v-deep {
      .mx-datepicker-popup{
          z-index:99999 !important;
      }
      .multiselect {
          color:$text-color !important;
      }
      .projectDropdownFilter{
        .multiselect {
          width:100%;
          margin-bottom: 4px;
          color:$text-color;
        }
        .multiselect__content-wrapper {
          display: none;
        }
        .multiselect__tag, .tags-style {
          background-color: $primary-background !important;
          border: $border-color;
          border-radius: 5px;
          margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
          background: $primary-background !important;
              border: $border-color !important;
        }

        .name-count-parent-wrap{
          background: transparent !important;
          border: none !important;
        }

        
        .multiselect__option--highlight {
          background: $bg-color-on-hover !important;
        }
        .multiselect__content {
          background: $secondary-background-color !important;
        }
        .multiselect__input,
        .multiselect__single {
          background: transparent !important;
          color: $text-color;
        }
        .multiselect__input:focus {
          outline: none;
          box-shadow: none;
        }
        .multiselect__tag-icon {
          color: $text-color !important;
        }
        .multiselect__tag-icon:focus,
        .multiselect__tag-icon:hover {
          background: $bg-color-on-hover !important;
          color: $text-color !important;
        }
        .multiselect__tag-icon:after {
          color: $secondary-text-color !important;
          font-size: 23px;
        }

        .multiselect__tag-icon {
          visibility: hidden;
        }

        .multiselect__tag:hover .multiselect__tag-icon {
          visibility: visible;
        }

        .multiselect * {
          font-size: $input-field-and-label-font-size !important;
          font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__placeholder {
          padding-top: 3px !important;
          margin-bottom:0px !important;
        }
        .multiselect {
          color: $text-color !important;
          font-size: $input-field-and-label-font-size !important;
          width: 99%;
          min-height: 38px;
        }
        .multiselect__single {
          padding-top: 3px;
        }
        .multiselect__option--selected {
          background: $bg-color-on-hover !important;
          color: $text-color;
        }
        .multiselect__content-wrapper {
          border: 1px solid $bg-color-on-hover !important;
          position: absolute;
          display: block;
          background: $text-color;
          width: 100%;
          max-height: 240px;
          overflow: auto;
          border: 1px solid $text-color;
          border-top: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          z-index: 50;
          -webkit-overflow-scrolling: touch;
        }

        .multiselect__current,
        .multiselect__option {
          line-height: 12px !important;
        }

        .multiselect--above .multiselect__content-wrapper {
          background: $secondary-background-color !important;
        }
        .multiselect__tags {
          background: $primary-background !important;
          height: auto;
          padding: 8px 40px 8px 8px;
          // min-height: 42px !important;
        }
        
        .mx-input{
            background-color:$primary-background !important;
            border: none !important;
            color: $text-color !important;
            height:100%;
        }
        .mx-input-wrapper{
            width:100%;
            height:100%;
        }
        .mx-datepicker-main{
            border: $border-color  !important;
            background: $primary-background!important;
            z-index: 9999 !important;
        }
        .mx-calendar-content .cell:hover{
            background-color: $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
            width:100%;
            height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
            width:100% !important;
            padding: 0 !important;
            border:$border-color !important;
            height: 27px !important;
            .mx-datepicker-main{
              z-index: 9999 !important;
            }
        }
        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
        }


        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-end;
            margin-inline-start:5px;
            position: relative;
            top: 5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            min-width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
        }
        .v-menu__content{
            width:150px !important;
        }
        .multiselect__tag {
            background-color: #131313;
        }
        .multiselect__tags{
            background: #161616;
            border: 1px solid #202020;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
             color:$text-color;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 5px;
            padding-top: 0px !important;
        }
        .multiselect__single {
            margin: 0px !important;
            height: 100%;
            display: flex;
            align-items: center;
        }  
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
            color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 23px;
        }
        .multiselect *{
            font-size: 14px !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: 12px !important;
            height: $input-field-height;
            min-height: $input-field-height;
        }
        .multiselect__option--selected{
           background: $bg-color-on-hover !important;
           color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: relative;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
          background: #1A1A1A !important;
        }
        .multiselect__tags {
            height: auto;
            padding-inline-start: 8px !important;
        }

        .multiselect__placeholder{
            display: flex;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 5px;

        }
      }
}
    
.custom-control-input:checked~.custom-control-label:before {
    color: #fff;
    border-color: #007bff;
    background-color: #007bff !important;
}


.custom-control-input{
  z-index: 9999;
}


.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}
.overWriteContainer{
  padding-inline-start: 0px !important;
}
.overWriteContMargin{
  margin-inline-start: 24px !important;
}
// .overWriteAdvIcon{
//   inset-inline-end :calc(100% - 713px) !important;
// }


.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
.bigger-checkboxes:focus{
  box-shadow: unset;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}
.custom-control-label{
    line-height:25px;
}

.custom-control-input:checked~.custom-control-label:before {
    color: #fff;
    border-color: #007bff;
    background-color: #007bff !important;
}

.config-desc,.custom-control{
  width: 100%;
  text-align: initial;
}

.custom-switch .custom-control-label::before{
    background: transparent;
}
.thumbnail-view-duration-label{
    color: #eee;
    position: absolute; 
    bottom: 0px;
    inset-inline-start: 0px;
    font-size: 10px;
    background: #01868c;
    padding: 1px 5px;
    justify-content: center;
    display: flex;
    border-radius: 3px;
  }
  .thumbnail-view-resolution-label{
    color: #eee;
    position: absolute;
    top: 0px;
    inset-inline-start: 0px;
    font-size: 10px;
    padding: 1px 5px;
    justify-content: center;
    display: flex;
    border-radius: 7px;
    align-items: center;
    margin: 2px;
    z-index: 9;
  }
  .res-FHD{
    // background: rgba(248, 120, 0, 0.6) !important;
    background: #f87800 !important;
    border: 1px solid #4a4a4a;
  }
  .res-fourK{
    background: #f8090199 !important;
    border: 1px solid #4a4a4a;
    //background: rgba(248, 9, 1, 0.6) !important;
  }
  .res-HD{
    // background: rgba(245, 241, 4, 0.6) !important;
    background: #f5f10499 !important;
    border: 1px solid #4a4a4a;
    color: #292a2b !important;
  }
  .res-SD{
    // background: rgba(29, 134, 140, 0.952) !important;
    background: #1d868cf3 !important;
    border: 1px solid #4a4a4a;
}

.file-extension-thumbnail-view{
  min-width: 51px;
  margin-inline-start: 5px;
  color: #aba7a7 !important;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dynamic-slug-name{
  margin-top:2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
